export const road = [
      {
        id: 9,
        thumbnail:
            "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh4dgy-i-_5wh7YnYNUp5wWWSlNnQ3ArnLgUgdZxpYAH0cw3xCHLdAf-e802srSl-8aCQm2O3FYmYXET7yDmP-JOLFeuhaIlhaMhJXLX6V7yDRv4R4t7Y89VVseZ3Nj88HThM0aSsbm5U0/w1200-h630-p-k-no-nu/school_taiikukan2.png",
        title: "M1-Nouns",
        subtitle: "Basic Level",
     

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            
            {  titulo:"🚩Writing Quiz  ", url: "https://forms.gle/QgiGFeXaXpEvaatU8"},
            {titulo:"📖 THERE IS / THERE ARE WITH SOME, ANY, SEVERAL, A LOT OF, MANY", url: "https://docs.google.com/presentation/d/1VwIJNGPfNm_3lmEpUoCDWMUtH7c1rEs7/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",},
            {titulo: "📖 Count / noncount nouns  some / any",url: "https://docs.google.com/presentation/d/1jH6YT2V1nqUZlZg87_nz2tL7dOuTOGubcKf5Wx2afc8/edit?usp=sharing",},
            {titulo: "📖 Compounds:  some / any / no",url: "https://docs.google.com/presentation/d/1tj-HacwRg_cFagev4icmdnngHJKihkozJZKF7YdSI1o/edit?usp=sharing", },
            { titulo: "📖 a lot of / much / many / How much …? /  How many …?",url: "https://docs.google.com/presentation/d/1-X6kwm4EcY28fchr9KjrksLA_bo0NW_REx2ulLewyik/edit?usp=sharing", },
            {titulo: "📖 a little / a few",url: "https://docs.google.com/presentation/d/1rR9yhIV9RjF_zUQe1YS8pQ6NJ3cizIfvaB-9G8O-jvE/edit?usp=sharing",},

            {
                titulo:
                    "📒[slides] UNIT 9:COUNT AND NON-COUNT NOUNS WITH SOME, ANY, MUCH, MANY",
                url: "https://docs.google.com/presentation/d/1R2ynzoB6PCzWW1ZG3fCSQih98U_S_Q28/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            
            {
                titulo: "📒[slides]Some and Any",
                url: "https://docs.google.com/presentation/d/1UaeuTpsBrQ5b4bOdHJCvX-XNPiTP1Fze/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides]Super Market Sections and Partitives",
                url: "https://docs.google.com/presentation/d/1L-Hv6M6viuSIc11rB_guEbzdWonYLCBU/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "Some vs Any",
                url: "https://wordwall.net/play/19154/472/1306",
            },
            {
                titulo: "A/an vs Some vs Any",
                url: "https://wordwall.net/play/54748/815/185",
            },
            {
                titulo: "📒[slides] UNIT 7:TOO, ENOUGH, NOT … ENOUGH",
                url: "https://docs.google.com/presentation/d/1C-HqoKGLmr7z6xrd7YLKNvoAlZctuPlw/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 7:QUANTIFIERS",
                url: "https://docs.google.com/presentation/d/1F9jXNU0_7pHQNI31dAfLd2xG_6GoFj3r/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "A/Some/Any I Exercises",
                url: "https://wordwall.net/play/10233/308/44280",
            },
            
            {  titulo:"06-📝[Challenge exam ] Check Point 02",url: "https://drive.google.com/file/d/10lHkTSgsdcwQ_hGKRztslK4vyiBlWX1_/view?usp=sharing" },
            {  titulo:"06-📝[Challenge exam ] Check Point 03",url: "https://drive.google.com/file/d/1zLH90bW_pMCL9HcUZto5c7Wqa_EyCBrc/view?usp=sharing" },

            {  titulo:"06-📝[Challenge exam ] Check Point 04",url: "https://drive.google.com/file/d/1EnoW42XNEawjftA1bKSeH0oJo9G3AHzB/view?usp=sharing" },

            {  titulo:"06-📝[Challenge exam ] Check Point 05",url: "https://drive.google.com/file/d/1ENHYzaj58usqyUFChs8ELBhDeeyITtJG/view?usp=sharing" },

            {  titulo:"06-📝[Challenge exam ] Check Point 06",url: "https://drive.google.com/file/d/1AVOmfvSbOUPPtc0d77y9YzM9yqsAXHMn/view?usp=sharing" },

            {  titulo:"06-📝[Challenge exam ] Check Point 07",url: "https://drive.google.com/file/d/1-qNBFmBf47x3qF6D8MNIQ626KtKAVbWQ/view?usp=sharing" },

            {  titulo:"06-📝[Challenge exam ] Check Point 08",url: "https://drive.google.com/file/d/1pJF_hC6nWNLc0UKcFFj44LO2LA1SkYtC/view?usp=sharing" },

            {  titulo:"06-📝[Challenge exam ] Check Point 09",url: "https://drive.google.com/file/d/1SPObWytxTPSAtog2ajYgo2YjAboLXKL5/view?usp=sharing" },

            {  titulo:"06-📝[Challenge exam ] Check Point 10",url: "https://drive.google.com/file/d/1FF4Ej6LblNh2l9uBSb1m3L7AfshaY418/view?usp=sharing" },

            {
                titulo: "📝[skill test] UNIT 1: Listening and writing WORD",
                url: "https://docs.google.com/document/d/1QYUOyZK6w3-IFXYP-Kojg-ezBrNQQf1f/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "🔊🦻[skill test]AUDIO TRACK",
                url: "https://drive.google.com/file/d/1yG1XxPQKV8wxNdkSb5EinETT5g1_GZGD/view?usp=sharing",
            },
            {
                titulo: "📽️[Video-Worksheet] Unit 1 Nice to meet you",
                url: "https://drive.google.com/file/d/1iIEtN9QL8NJIMZOTS75pJPO1OsyveWxd/view?usp=sharing",
            },
            
        ],
    },
     {
        id: 9,
        thumbnail:
            "https://i.ibb.co/rcqJNmR/Black-White-and-Red-Simple-Shield-Shape-Football-Club-Logo-4-removebg-preview.png",
        title: "Pronunciation 👄",
        subtitle: "Basic Level",
     

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            {
                titulo: "💣PRONUNCIACIÓN en INGLÉS (Presentación)👄",
                url: "https://www.youtube.com/watch?v=-YocPrBjydE&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&ab_channel=MyEnglishBro",
            },
            {
                titulo: "Trucos con la T",
                url: "https://www.youtube.com/watch?v=sh1-WReYeYY&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=2&ab_channel=MyEnglishBro",
            },
            {
                titulo: "Dropped T",
                url: "https://www.youtube.com/watch?v=MBPAI8TI-HA&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=3&ab_channel=MyEnglishBro",
            },
            {
                titulo: "T Flap",
                url: "https://www.youtube.com/watch?v=TAdE9TjixHk&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=4&ab_channel=MyEnglishBro",
            },
            {
                titulo: " Omission ",
                url: "https://www.youtube.com/watch?v=EbfroOu4_EU&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=5&ab_channel=MyEnglishBro",
            },
            {
                titulo: " T flap 2 ",
                url: "https://www.youtube.com/watch?v=8_-ABxzg3gE&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=6&ab_channel=MyEnglishBro",
            },
            {
                titulo: " T flap 3",
                url: "https://www.youtube.com/watch?v=w2BDLl5TVvA&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=7&ab_channel=MyEnglishBro",
            },
            {
                titulo: " T as Sh",
                url: "https://www.youtube.com/watch?v=VPFclhpx__s&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=8&ab_channel=MyEnglishBro",
            },
            {
                titulo: " Consideraciones al Pronunciar",
                url: "https://www.youtube.com/watch?v=717NdjUV9Po&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=9&ab_channel=MyEnglishBro",
            },
            {
                titulo: " T/D between 2 consonant sounds",
                url: "https://www.youtube.com/watch?v=vLUv888ckbk&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=10&ab_channel=MyEnglishBro",
            },
            {
                titulo: " Mastering Rhythm and Stress Presentation",
                url: "https://www.youtube.com/watch?v=z8aqyyXpfYg&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=11&ab_channel=MyEnglishBro",
            },
            {
                titulo: " Stress: The Missing Piece in Your English Pronunciation Puzzle",
                url: "https://www.youtube.com/watch?v=1ZQW2TETlZ4&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=12&ab_channel=MyEnglishBro",
            },
            {
                titulo: " Rhythm in English: Tips and Tricks for Improved Pronunciation and Fluency",
                url: "https://www.youtube.com/watch?v=IZk_QMWlq4o&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=13&ab_channel=MyEnglishBro",
            },
            {
                titulo: " Stress: The Missing Piece in Your English Pronunciation Puzzle II",
                url: "https://www.youtube.com/watch?v=yXhEUuVD9t0&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=14&ab_channel=MyEnglishBro",
            },
            {
                titulo: "The Power of Words: Understanding Content and Function Words",
                url: "https://www.youtube.com/watch?v=Qc4gX3xqHtA&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=15&ab_channel=MyEnglishBro",
            },
            {
                titulo: "Content vs. Function Words: The Building Blocks of Language",
                url: "https://www.youtube.com/watch?v=c1i7FNh9Sbc&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=16&ab_channel=MyEnglishBro",
            }
           



            
        ],
    },
      
    {
        id: 8,
        thumbnail:
            "https://i.ibb.co/0XR5yjD/990527648dc1fe389bb8568a632839e8-removebg-preview.png",
        title: "M2 - Past Tense I",
        subtitle: "Basic Level",

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            {titulo: "📖 UNIT 12:GOING TO",url: "https://docs.google.com/presentation/d/1SERr4FC0uid44aV7TBYFbu2UqdKgltiV/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true", },

            {titulo: "📖 be: Simple past  Affirmative and negative", url: "https://docs.google.com/presentation/d/1B7OI2bdC87AnfKKO4d_3Yhxim9zTeQGGzWCwc7AVkko/edit?usp=sharing",},
            {titulo: "📖 be: Simple past   Interrogative and short answers",url: "https://docs.google.com/presentation/d/1ml4Elz9yZMnjaPzktFBi7LLm5ZUYRgATCQtK72Rt-ZI/edit?usp=sharing", },
            {  titulo:"🧩 Simple Past was/were",url: "https://wordwall.net/play/62938/423/342" },

            {titulo: "📖 Question words  with was / were",url: "https://docs.google.com/presentation/d/1gTtHyLBBKmepH7uHASACv4X80e5k8IKI3bVQsjjP2DA/edit?usp=sharing",},
            {titulo: "📖 Simple past Regular verbs Affirmative", url: "https://docs.google.com/presentation/d/1DpJnvEGUNzzE77-OLCgYvyTMf-o0C_PXo9-e1SLx7Fc/edit?usp=sharing",},
            {  titulo:"🧩 Simple Past Regular Verbs",url: "https://wordwall.net/play/15209/196/99109" },
            {  titulo:"🧩 Simple Past Complete Regular Verbs",url: "https://wordwall.net/play/7639/322/54002" },

            {titulo: "📖 Simple past:  Irregular verbs Affirmative", url: "https://docs.google.com/presentation/d/19X3T5vbawbDcFFgxc2DlqfaFwaNsFkQMlFUsE9zgiPU/edit?usp=sharing", },
            {titulo: "📚 Los Verbos Irregulares ", url: "https://drive.google.com/file/d/1RpV1uLe-A215sfP1S954zi2zQs_XDvDg/view?usp=share_link", },
            { titulo: "📚 Los Verbos Irregulares II ", url: "https://drive.google.com/file/d/1EhALfkVQb-G5ylK9qMc674zmh8LWd-kT/view?usp=share_link",},
            {  titulo:"🧩 Simple Past Irregular Verbs",url: "https://wordwall.net/play/15208/131/43596" },
            {  titulo:"🧩 Simple Past Irregular Verbs II",url: "https://wordwall.net/play/25350/524/3505" },

            {titulo: "📖 Simple past  Negative",url: "https://docs.google.com/presentation/d/1VpPwGUKg1XsZNBatr46QYnss9emq0vN_pbj_bsXKg8A/edit?usp=sharing",},

            {titulo: "📖 Simple past   Interrogative and  short answers",url: "https://docs.google.com/presentation/d/19tQmwXnpFBPUgtg5mN2lAovJ7oQVMeTU9M_8WOPQIhY/edit?usp=sharing",},
            {  titulo:"🧩 Simple Past Order the",url: "https://wordwall.net/play/13891/224/58926" },

            {titulo: "📖 Question words + simple past",url: "https://docs.google.com/presentation/d/1xpXeEcVnzABaHDX-2agE6CjI3QL0QWi3SKhZiv6yYj4/edit?usp=sharing",},
            { titulo: "📖 SIMPLE PAST WITH WHEN CLAUSES",url: "https://docs.google.com/presentation/d/1gU_JXxoAp3KFVAe9-VI8pw-E7L4iXs_S/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true", },
            {
                titulo: "📒[slides] UNIT 5:PRESENT PERFECT AND SIMPLE PAST",
                url: "https://docs.google.com/presentation/d/1bpMRMy7LVba68bhwB6w2KUEXmD7n-MAP/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
          
            {  titulo:"🧩 Present Perfect VS sIMPLE PAST",url: "https://wordwall.net/play/3872/569/6556" },
            {  titulo:"🧩 Present Perfect VS sIMPLE PAST II",url: "https://wordwall.net/play/3580/893/7297" },

            
        ],
    },
      {
        id: 5,
        thumbnail: "https://i.ibb.co/9wVtSxZ/B2-FIRST-18.png",

        title: "M1-Listening Center ",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
           
            {  titulo:"[ ▶️💿 Listening Track] Be-Verbs-Introduction", url: "https://drive.google.com/file/d/17Lf7YVWWL3J6ZlxcBGo_uKJLeN3aeClc/view?usp=sharing"},
            {  titulo:"[ 🎧📑 Listening Worksheet] Be-Verbs-Introduction", url: "https://drive.google.com/file/d/1KfV3ia7U0wgt0w382Xfu4wgKgvSG7oDB/view?usp=sharing"},
            {  titulo:"[ ▶️💿 Listening Track] Be-Yes-No-Questions", url: "https://drive.google.com/file/d/1QdV0ezdTMqw_-XY6EQhbU7XWtIbDBfLT/view?usp=sharing"},
            {  titulo:"[ 🎧📑 Listening Worksheet] Be-Yes-No-Questions", url: "https://drive.google.com/file/d/1sRDMHlTvic6YDluhWQ3vJmwFIxodWFee/view?usp=sharing"},
            {  titulo:"[ ▶️💿 Listening Track] Likes-Fruits", url: "https://drive.google.com/file/d/1jK724U6fY7fsfH49MMp_P5aeI9WxKWSO/view?usp=sharing"},
            {  titulo:"[ 🎧📑 Listening Worksheet] Likes-Fruits", url: "https://drive.google.com/file/d/1neV1tlIP3aw7wCvfiOcAcAdZkYP8P1pU/view?usp=sharing"},


            {  titulo:"[ ▶️💿 Listening Track] Verbs -Present Simple", url: "https://drive.google.com/file/d/1E3LHvSXWGIWD_VlvFiZU_SPGrYRQI2qp/view?usp=sharing"},
            {  titulo:"[ 🎧📑 Listening Worksheet] Verbs -Present Simple", url: "https://drive.google.com/file/d/1_UQf3VANxdA62__5oBLnngJSYhmnTx5L/view?usp=sharing"},

            {  titulo:"[ ▶️💿 Listening Track] Yes / No Questions with Verbs", url: "https://drive.google.com/file/d/1sQ5GIqQPAepKqpzAI8X8IwZFkUn54xYY/view?usp=sharing"},
            {  titulo:"[ 🎧📑 Listening Worksheet] Yes / No Questions with Verbs", url: "https://drive.google.com/file/d/1dyB2TOcY9wN-LnoCSpqbDUqTTfhPyDiu/view?usp=sharing"},

            {  titulo:"[ ▶️💿 Listening Track] Third Person Singular", url: "https://drive.google.com/file/d/1dpZcurygltj5nPjHC5f-M-Nm9az0mEFJ/view?usp=sharing"},
            {  titulo:"[ 🎧📑 Listening Worksheet] Third Person Singular", url: "https://drive.google.com/file/d/1b1Ne9hLfpUDTI7ahvrwtCIfAkiPiXI4C/view?usp=sharing"},


            {  titulo:"[ ▶️💿 Listening Track] Adjectives", url: "https://drive.google.com/file/d/1eP9vlMcWY5rQeElEyMwMRc9no7JKucgN/view?usp=sharing"},
          
            {  titulo:"[ 🎧📑 Listening Worksheet] Adjectives", url: "https://drive.google.com/file/d/1bPduv45i_ih-KU2dt9M7QUpXnFluwPMz/view?usp=sharing"},
      
      
            {  titulo:"[ ▶️💿 Listening Track] Days of the week", url: "https://drive.google.com/file/d/1S8LCubZ3TTG_b77lhxpln4TPJ7SaOTCr/view?usp=sharing"},
            {  titulo:"[ 🎧📑 Listening Worksheet] Days of the week", url: "https://drive.google.com/file/d/19lQ7wqAtffFMAS2Bs9opcn8GJ9f2_Gew/view?usp=sharing"},
      
      
        ],
    },
    
    {
        id: 7,
        thumbnail: "https://i.ibb.co/9wVtSxZ/B2-FIRST-18.png",
        title: "M1- Present Simple vs Progressive",
        subtitle: "Pre-Intermediate",

        dateAdded: "Basic 09 ",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
            {
                titulo: "📒[slides] Explanation Non Action Verbs",
                url: "https://docs.google.com/presentation/d/1iRId98sfwylaVNdIwLgAp1fTvSyFxzQw/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "🎯 Stative Verbs Group Exercise",
                url: "https://wordwall.net/play/34083/656/824",
            },
            {
                titulo: "🎯 Stative Verbs vs Dynamic Verbs 1",
                url: "https://wordwall.net/play/35891/342/229",
            },
            {
                titulo: "🎯 Stative Verbs vs Dynamic Verbs 2",
                url: "https://wordwall.net/play/29172/527/2575",
            },
            { titulo: "💡🎦 Present Tense Simple and Progressive 01 ",url: "https://drive.google.com/file/d/1nfWk8xLzG10nr3XrKVC3bpX5w00jN81P/view?usp=sharing", },

            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/19FdH7nnsqL0Ez9siyiFv3PCEvt4EknFv/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1HRBxbp2b_5kcObTcgjMDmRKXH-xW0O4M/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1aAeXIW3wmnJwJjUTcCE6m7PV9aElcgeB/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1ugupTJWoGVpoH7q_UxAivmklT21IBsKv/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1HlMPxx9G-eXDvAkpnoYcD_qhH8DRcUt_/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1fQ23Xn4bXCSZJSaHGiWf5utUXeHAK0ma/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1Gjn3DIa6xRDKcbKFvUopOvzMTA7vnW02/view?usp=sharing", },
            {titulo: "📒[slides] Simple present /  Present progressive",url: "https://docs.google.com/presentation/d/1aGIUs6OxD2chdWfcU7HACie_D64bc3vy3NE_OB-2Ztw/edit?usp=sharing", },

            
            {titulo: "📒[slides] Present progressive for future",url: "https://docs.google.com/presentation/d/127VXd9ZK8i7BItgdXOik5VSWc9_G7dWRn7sMEbaFEUI/edit?usp=sharing",},

            {titulo: "📒[slides] Compounds: every",url: "https://docs.google.com/presentation/d/1RmaKN7jY5ej_nCVRgFSTI1b0tCMPx7IqZxLbHvDuK_E/edit?usp=sharing",},
           
            
            {titulo: "📒[slides] Comparative adjectives",url: "https://docs.google.com/presentation/d/1UwvUgRFxdCDPk648imeb3G9_V3rQ58e7UpvL7iD62lw/edit?usp=sharing", },
            {titulo: "📒[slides] Superlative adjectives", url: "https://docs.google.com/presentation/d/1EGA1g6Wx7aQTZYGeXUkK_PDeF3CXNLcU-sFWuhpxAmQ/edit?usp=sharing",},
            { titulo: "📒[slides] Verb + -ing form / infinitive", url: "https://docs.google.com/presentation/d/1V9GjtW5BRs2n4knhrQfQbeHkvLnJPP7tUTCmokQzeBQ/edit?usp=sharing",},

           
            {
                titulo: "📒[slides]Food in English + Describing food in English",
                url: "https://docs.google.com/presentation/d/1ea3d6wBVgcjuOsMoq3_nAuI-ZT9SrIxa/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
           
            {
                titulo: "📒[slides] Vocabulary-At the Restaurant 1 ",
                url: "https://docs.google.com/presentation/d/1Hw5NLZdI9y9rruKi--qHDiFxcCH07WYp/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            {
                titulo: "Conversation At the Restaurant 1 ",
                url: "https://docs.google.com/presentation/d/174rPUtaLiCPNGmHnYgK-LEgdubJOQtoS/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

           
        ],
    },
    {
        id: 13,
        thumbnail:
            "https://i.ibb.co/0XR5yjD/990527648dc1fe389bb8568a632839e8-removebg-preview.png",
        title: "General Vocabulary (B1)",
        subtitle: "Basic Level",

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            {
                titulo: "✍GV001 - MAKE and DO",url: "https://drive.google.com/file/d/1UEYWUuHD3FKzJJFSG_OP9lBEAqhUx54k/view?usp=sharing",
            },
            { titulo: "✍ GV002 - MAKE and DO",url: "https://drive.google.com/file/d/1QPzo8Ck0ZevE8NE4rk7sCKJ-j9dZfQVZ/view?usp=sharing", },

            { titulo: "✍ GV003 - Opposites",url: "https://drive.google.com/file/d/1xoPKqzxYNSvH8rBQnKnAN_xVMAL7aio2/view?usp=sharing", },

           
            { titulo: "✍ GV004 - Opposites  ",url: "https://drive.google.com/file/d/14KyyQcO_HlG1CH3D8p12D55cnA2HqkmF/view?usp=sharing", },
            { titulo: "✍ GV005 - MAKE, DO, HAVE and GET  ",url: "https://drive.google.com/file/d/1ezVaxDVz1rfXiSzDYpFgzXYKGp9SBhUJ/view?usp=sharing", },
            { titulo: "✍ GV006 - Opposites  ",url: "https://drive.google.com/file/d/1R6pbUOru-AXvwM9yOb3JqTtTGzws6CAC/view?usp=sharing", },
            { titulo: "✍ GV007 - Nouns and Activities  ",url: "https://drive.google.com/file/d/1pgo4T6hPx0ybXAzLonEYE1yRLC1W3UPd/view?usp=sharing", },



          
           

            
        ],
    },
    
    
    {
        id: 99,
        thumbnail:
            "https://i.ibb.co/VL5G53c/My-english-bro-Personajek-09.png",
        title: "GUIAS MAESTRIA GRAMMAR ",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
           
           
          
            {  titulo:"[📑 Tense Infographic ", url: "https://drive.google.com/file/d/1Mxxxxi0x13HrO5EvSECowdaRF0Vg9fIK/view?usp=sharing"},

            {  titulo:"[📑 Present Simple", url: "https://drive.google.com/file/d/1uosvGKLwegu9ECo9TZTG3uJd79ku4_G2/view?usp=sharing"},
            {  titulo:"[📑 Present Progressive", url: "https://drive.google.com/file/d/15m5KpSZhu7Q1vop2-MiqlARFmY8jLx9u/view?usp=sharing"},
            {  titulo:"[📑 Past Simple", url: "https://drive.google.com/file/d/19wgEn7E6c-hBR1q08aSUU7ibHn8ERRl-/view?usp=sharing"},
            {  titulo:"[📑 Present Perfect", url: "https://drive.google.com/file/d/11x2FcIbUKSvFsAm2PyyfTOQ5zyYXE92i/view?usp=sharing"},

            {  titulo:"[📑 Present Perfect Progressive", url: "https://drive.google.com/file/d/1CoGNeh_2_0CkmXYzSkwugtCx185XJUp-/view?usp=sharing"},

        ],
    },
    {
        id: 10,
        thumbnail:
            "https://i.ibb.co/W2FY74b/level5.png",
        title: "Modal Verbs I",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            {titulo: "📒[slides] have to   Affirmative and negative",url: "https://docs.google.com/presentation/d/1ju_6UW5MqJkQx8ha63DXUkqdMIosY7yFkWo2VEFaBiM/edit?usp=sharing", },
            {titulo: "📒[slides] must / mustn’t",url: "https://docs.google.com/presentation/d/1trH8e--NmFTr9EVn-3bCGRiMmwg829FAfxcMiM0ZluY/edit?usp=sharing",},
            {titulo: "📒[slides] mustn’t / don’t have to", url: "https://docs.google.com/presentation/d/10cVuC3HrwV7jHSn_olYGfm3E_GibC-WeuJE3aB-mV_g/edit?usp=sharinge",},
            {
                titulo: "📒[slides] Can-Cannot Affirmative | Negative",
                url: "https://docs.google.com/presentation/d/1eKvqH6AOsKqLqqEudE2jChjZBn1bYSxq/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            {
                titulo: "📒[slides] Can-Cannot Questions",
                url: "https://docs.google.com/presentation/d/1Qpes0MERe7qfFf0ZK8JJHgPzcq3RZ4vF/edit?usp=share_link&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {titulo: "📒[slides] have to   Affirmative and negative",url: "https://docs.google.com/presentation/d/1ju_6UW5MqJkQx8ha63DXUkqdMIosY7yFkWo2VEFaBiM/edit?usp=sharing", },
            {titulo: "📒[slides] must / mustn’t",url: "https://docs.google.com/presentation/d/1trH8e--NmFTr9EVn-3bCGRiMmwg829FAfxcMiM0ZluY/edit?usp=sharing",},
            {titulo: "📒[slides] mustn’t / don’t have to", url: "https://docs.google.com/presentation/d/10cVuC3HrwV7jHSn_olYGfm3E_GibC-WeuJE3aB-mV_g/edit?usp=sharinge",},
            {
                titulo: "📒[slides] UNIT 3:MODALS OF PERMISSION, REQUEST, AND OFFER",
                url: "https://docs.google.com/presentation/d/1BXcYnCIF8JUQobGPG8BRQcBxLNTajgIu/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
           
            {
                titulo: "📒[slides] UNIT 5:SHOULD AND OUGHT TO FOR ADVICE",
                url: "https://docs.google.com/presentation/d/1UQ0jqkKaJld2WJKsdaDMUFhLDVHlxOu_/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo:
                    "📒[slides] UNIT 6:HAVE TO FOR OBLIGATION AND NEED TO FOR NECESSITY",
                url: "https://docs.google.com/presentation/d/1PzeZoVRIRqcpQ6BFvLJRYuOeC4UmQStn/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {  titulo:"📝Modal Verbs 01 ",url: "https://drive.google.com/file/d/1Zgn5KfbaEf7exIqRM68RQTYBMcoaTOoP/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 02 ",url: "https://drive.google.com/file/d/15KaDhw2YaEcm7wXwU9EDVmR7pGH-XmU0/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 03 ",url: "https://drive.google.com/file/d/1KZS2o5INbRPQompRGWlp1E37JdjTl91I/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 04 ",url: "https://drive.google.com/file/d/1IlbtmcVPxi2tVOnH5cpKvy7TgeyNgQkE/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 05 ",url: "https://drive.google.com/file/d/1TkRPNcrpra3uhWXzH4fMBWZu7J8NFBK_/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 06 ",url: "https://drive.google.com/file/d/1C5BNy8t3qK5Ke9cyVcWorPNVS07hcPH5/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 07 ",url: "https://drive.google.com/file/d/16enX5sTyWnLGlZxUMEBCNRfkPzWtVr2M/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 08 ",url: "https://drive.google.com/file/d/1lU75k9ZEKJM7wRsUpLz8LaUV6MuV8BRJ/view?usp=sharing"},

            


        ],
    },
    
    
    
    {
        id: 12,
        thumbnail:
            "https://i.ibb.co/0XR5yjD/990527648dc1fe389bb8568a632839e8-removebg-preview.png",
        title: "M3 - Present Perfect Tense",
        subtitle: "Basic Level",

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
           

            { titulo: "✍ Past and Present Perfect Tense - Simple Form",url: "https://drive.google.com/file/d/1D6keuz7pTkAnNv7mr2WRWoNIIlR5xaAu/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1GWFlQ8RvPK7qb3S8HLBhKTlBONeogy0H/view?usp=sharing", },

            { titulo: "✍ Past Tense: Simple and Progressive",url: "https://drive.google.com/file/d/1Cc3RqGtZefUPxDSohH0Xssr4OSO5uftZ/view?usp=sharing", },
            { titulo: "✍ B1 Simple Past , Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/10efo7YOPNaICX_E6_DQJsYZ5ctxm2xYQ/view?usp=sharing", },

           
            { titulo: "✍ Future Tense  ",url: "https://drive.google.com/file/d/1J6r3JFYzr-U4CzRQihyMcl6uB2Ms7bu0/view?usp=sharing", },
           
            {
                titulo: "📒[slides] UNIT 1: PRESENT PERFECT + YET/ALREADY",
                url: "https://docs.google.com/presentation/d/1RA-WHyxhAoZS3nE2GzwITzIArZLGDTeP/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },


            {
                titulo: "📒[slides] UNIT 4:PRESENT PERFECT— EVER/NEVER",
                url: "https://docs.google.com/presentation/d/12ccx9tsZGF_Ywm7pVc-YS5m2SXiV_g9U/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 4:PRESENT PERFECT—HOW LONG AND FOR/SINCE",
                url: "https://docs.google.com/presentation/d/1H5WPi2HTyUg7GHdLBuGZBXbnPHs5oG7S/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {  titulo:"🧩 Present Perfect Structure",url: "https://wordwall.net/play/3970/867/72998" },
            {  titulo:"🧩 Present Perfect FOR VS sINCE",url: "https://wordwall.net/play/12605/576/3362" },
           
            {
                titulo: "PRESENT PERFECT Exercises Grammar",
                url: "https://wordwall.net/play/20930/047/3447",
            },
            {
                titulo: "📒[slides] Explanation Present Perfect-Since and for",
                url: "https://docs.google.com/presentation/d/1nIn9oQtj9P7RcG5SwCXM_kFQOHYS3yin/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            {
                titulo: "Since and for",
                url: "https://wordwall.net/play/22172/068/39116",
            },
            {
                titulo: "📒[slides] SO, SUCH,TOO, ENOUGH",
                url: "https://docs.google.com/presentation/d/1-esOg7O9L2nl24VdBtrtRpCWM3BvhOyg/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] SEPARABLE AND NON-SEPARABLE PHRASAL VERBS",
                url: "https://docs.google.com/presentation/d/18JEefaYUzpFKO_NnwPuTsfK0ds4wSamk/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
        ],
    },
      {
        id: 27,
        thumbnail:
            "",
        title: "Duolinguo",
        subtitle: "Upper-Intermediate",

        dateAdded: "B2",
        channel: "Upper-Intermediate",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
          
            
            {
                titulo: "📒[slides] Read and Complete 1",
                url: "https://docs.google.com/presentation/d/12klLnHNvAHZ3BxdA7zVSdiY6UWZKgWjE/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Read and Complete 2",
                url: "https://docs.google.com/presentation/d/1eWCBSCR3CL8UfHAumCcc70V8l9AtOSaI/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Read and Complete Samples",
                url: "https://docs.google.com/document/d/1vKaqA0u7eHZeIBTfwp_m40DzPSqfD12J/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Read and Complete 3",
                url: "https://docs.google.com/presentation/d/1vDvxBxwAUQzF2BQJ8JLP8o6mBIbAmf0t/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Speaking Samples",
                url: "https://docs.google.com/document/d/13nEGPwnjIxDw6io6tBWyJTZ_uaMgWu9P/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true",
            }
           
        ],
    },
     {
        id: 14,
        thumbnail:
            "https://i.ibb.co/0XR5yjD/990527648dc1fe389bb8568a632839e8-removebg-preview.png",
        title: "M4 - Past Simple Vs Present Perfect",
        subtitle: "Basic Level",

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            {
                titulo: "📒[slides] UNIT 5:PRESENT PERFECT AND SIMPLE PAST",
                url: "https://docs.google.com/presentation/d/1bpMRMy7LVba68bhwB6w2KUEXmD7n-MAP/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            { titulo: "✍ Past and Present Perfect Tense - Simple Form",url: "https://drive.google.com/file/d/1D6keuz7pTkAnNv7mr2WRWoNIIlR5xaAu/view?usp=sharing", },

            { titulo: "✍ B1 Simple Past , Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/10efo7YOPNaICX_E6_DQJsYZ5ctxm2xYQ/view?usp=sharing", },

           
            { titulo: "✍ Future Tense  ",url: "https://drive.google.com/file/d/1J6r3JFYzr-U4CzRQihyMcl6uB2Ms7bu0/view?usp=sharing", },
           



          
           

            
        ],
    },
    {
        id: 11,
        thumbnail:
            "https://i.ibb.co/rcqJNmR/Black-White-and-Red-Simple-Shield-Shape-Football-Club-Logo-4-removebg-preview.png",
        title: "M2-Past Simple vs Progressive",
        subtitle: "Basic Level",
     

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [

            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1GWFlQ8RvPK7qb3S8HLBhKTlBONeogy0H/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/18h8QAkzm5UIzr-TF3DywBw_F-KtkjUYY/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1LCS98Vmh3gzPntxzCx5kX_EdackIK0v_/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1gxGscWmK3hDwJTXbNQpUEKlWSh_J9VLG/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1_3IiO9AC-y6Ks5RZujHdQyaWKKeMO9pu/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1Cc3RqGtZefUPxDSohH0Xssr4OSO5uftZ/view?usp=sharing", },
            {  titulo:"✍️Practica Integradora 1", url: "https://docs.google.com/document/d/1dEid7CxmlAwFluGbugI-3zH__ktx_KrV/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true", },
            {  titulo:"✍️Test 01", url: "https://docs.google.com/document/d/1dEid7CxmlAwFluGbugI-3zH__ktx_KrV/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true", },

            
            {
                titulo: "📒[slides] UNIT 1:PAST PROGRESSIVE AND SIMPLE PAST",
                url: "https://docs.google.com/presentation/d/1D_k7NtZcVeZVozYIn4_Ub2ozwkub8uLP/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Explanation Past Progressive vs Past Simple",
                url: "https://docs.google.com/presentation/d/1OOieX_KRY80lbTVWR9iNmsQdeljR8p2u/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 2:COMPARATIVES WITHAS … AS / NOT AS … AS",
                url: "https://docs.google.com/presentation/d/13nJDZAQHhszP7Upr6VJdv4954_gwfHnP/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
           
            {
                titulo: "📒[slides] UNIT 3:REFLEXIVE PRONOUNS",
                url: "https://docs.google.com/presentation/d/1mH6MFHK3pXVZgHj7WOu4xvnRdZN9C3gJ/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },



            
        ],
    },
     {
        id: 9,
        thumbnail:
            "https://i.ibb.co/rcqJNmR/Black-White-and-Red-Simple-Shield-Shape-Football-Club-Logo-4-removebg-preview.png",
        title: "A2-Past Progressive",
        subtitle: "Basic Level",
     

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            {
                titulo: "📒[slides] UNIT 1:PAST PROGRESSIVE",
                url: "https://docs.google.com/presentation/d/1HAWLxWFAbFNcrMbfGDVprjNC29Ziuw_N/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Explanation Past Progressive",
                url: "https://docs.google.com/presentation/d/1vdes1YGErLQlydpHdRVOv1MJcymHiNWr/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
           



            
        ],
    },
    {
        id: 0,
        thumbnail:
            "https://i.ibb.co/Jwz8bgPJ/B2-FIRST-30.png",
        title: "Ubica tu nivel",
        subtitle: "Centro de Clasificación ",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            { titulo: "[M1-10] Exam", url: "https://drive.google.com/file/d/12O4mX_tZIsRqULe8iJVUvvr_q1witI_P/view?usp=sharing" },
            { titulo: "[M1-11] Exam", url: "https://drive.google.com/file/d/1Hg6By1hFOK_NOmOIKHttDHZ8BUZsuvhI/view?usp=sharing" },
            { titulo: "[M1-12] Exam", url: "https://drive.google.com/file/d/1IxdTDk06FHkGIYOrNbcml6AEutsLrp8I/view?usp=sharing" },
            { titulo: "[M2-01] Exam", url: "https://drive.google.com/file/d/1Kmx6qI5eAKaMbWINIevF1m2pr5nDNzmB/view?usp=sharing" },
            { titulo: "[M2-02] Exam", url: "https://drive.google.com/file/d/1H4YQQbU1DjuJAhhy6Ee7PETKtUdBZL7o/view?usp=sharing" },
        ],

            
        
    },
    {
        id: 4,
        thumbnail: "https://i.ibb.co/Jwz8bgPJ/B2-FIRST-30.png",
        title: " Antes del Curso",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"Presentación del Curso",url: "https://www.youtube.com/watch?v=_1DEJIOcJmY&t=2s"},        

        ],
    },
     {
        id: 2,
        thumbnail:
            "",
        title: "M5 - Conditionals",
        subtitle: "Pre-Intermediate",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
            
            {
                titulo: "📒[slides] UNIT 12:ZERO AND FIRST CONDITIONALS",
                url: "https://docs.google.com/presentation/d/1onYqAtCakGRcvxqsWTekI0t1RvDKsaFE/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 12:SECOND CONDITIONAL",
                url: "https://docs.google.com/presentation/d/1QsqN95d1bMRf3kkUx3glrk2VSBU0sQRd/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            
            { titulo: "✍ IF001 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/1zkFdLJpLESep41DLgUElfhiyuBzCU_fi/view?usp=sharing", },
            { titulo: "✍ IF002 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/1eQ-z-lbU8tKm_BZgrrgJwfkvl2Erbf2c/view?usp=sharing", },
            { titulo: "✍ IF003 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/182p9f-HK7c0eGODpwB3VstwcwQKgmtH7/view?usp=sharing", },
            { titulo: "✍ IF004 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/19z4Pi3T60d7n505lFrt22npAN8bMZG4d/view?usp=sharing", },
            { titulo: "✍ IF005 - IF-Clauses - Missing Sentence Types ",url: "https://drive.google.com/file/d/12FhAI14xsU_5O_Bau-AQFPIQPMwQrIPT/view?usp=sharing", },
            { titulo: "✍ IF006 - IF-Clauses - Missing Sentence Types ",url: "https://drive.google.com/file/d/1FiXA09T66glsOEsLQ6zJv86uzRS5NBAC/view?usp=sharing", },
            { titulo: "✍ IF008 - IF-Clauses - Conditional 1 ",url: "https://drive.google.com/file/d/1frj2F8CUX2wo_ASftPHyFFK037reIw9E/view?usp=sharing", },
            { titulo: "✍ IF009 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/1dk_3njjacg-x5I-707uoA6ieWhAB8TyU/view?usp=sharing", },
            { titulo: "✍ F010 - IF Clauses - Type 1 ",url: "https://drive.google.com/file/d/1cW9NMcLR6qwyc9TgGIgwcJl41iH9tWMA/view?usp=sharing", },
            { titulo: "✍ IF011 - IF Clauses - Type 2 ",url: "https://drive.google.com/file/d/1H_R3hcWhSwJCTfL____KykDG1pfuyoK5/view?usp=sharing", },
            { titulo: "✍ IF012 - IF Clauses - Type 3 ",url: "https://drive.google.com/file/d/1cG8XOFirGzvJJx7b_Xvv1c1uR38CuBlH/view?usp=sharing", },
        ],
    }, 
    
    {
        id: 2,
        thumbnail:
            "",
        title: "M4 - Future Simple",
        subtitle: "Pre-Intermediate",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
            

            {titulo: "📒[slides] Present progressive for future",url: "https://docs.google.com/presentation/d/127VXd9ZK8i7BItgdXOik5VSWc9_G7dWRn7sMEbaFEUI/edit?usp=sharing",},

            {titulo: "📒[slides] Compounds: every",url: "https://docs.google.com/presentation/d/1RmaKN7jY5ej_nCVRgFSTI1b0tCMPx7IqZxLbHvDuK_E/edit?usp=sharing",},
           
            
            {titulo: "📒[slides] Comparative adjectives",url: "https://docs.google.com/presentation/d/1UwvUgRFxdCDPk648imeb3G9_V3rQ58e7UpvL7iD62lw/edit?usp=sharing", },
            {titulo: "📒[slides] Superlative adjectives", url: "https://docs.google.com/presentation/d/1EGA1g6Wx7aQTZYGeXUkK_PDeF3CXNLcU-sFWuhpxAmQ/edit?usp=sharing",},
            { titulo: "📒[slides] Verb + -ing form / infinitive", url: "https://docs.google.com/presentation/d/1V9GjtW5BRs2n4knhrQfQbeHkvLnJPP7tUTCmokQzeBQ/edit?usp=sharing",},

         
            
            
        ],
    },      
    {
        id: 19,
        thumbnail:
            "",
        title: "M4 - Relative Clauses I",
        subtitle: "Pre-Intermediate",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
            

            {titulo: "📒[slides] Relative Clauses Explanation",url: "https://drive.google.com/file/d/1cxrD9paWOcm3w7pLDmE_WvAVi2FJQI1x/view?usp=sharing",},
            
            {titulo: "📒[slides] Defining Relative Clauses Exercise 1",url: "https://drive.google.com/file/d/1vLOQ-v7JohxwCcGIeIPZRB0VEIvE1P5b/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 1 key",url: "https://drive.google.com/file/d/1eUbQC4nby3BU4ob6iXnWLBgn1ucZtzGv/view?usp=sharing",},

            {titulo: "📒[slides] Defining Relative Clauses Exercise 2",url: "https://drive.google.com/file/d/1zuEnn8IqoyVEFDGtioyJoAaF9beihzmL/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 2 key",url: "https://drive.google.com/file/d/1nAfUnBlJZYD6NAyXyrwcXyEGfEkGNMap/view?usp=sharing",},

            {titulo: "📒[slides] Defining Relative Clauses Exercise 3",url: "https://drive.google.com/file/d/1JHS5Kog6HeXhj5GMgKY6GoafIv69Leoj/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 3 key",url: "https://drive.google.com/file/d/1g6Bcda-4oWQ_1ugTLgn-X2l4lAvRbmF2/view?usp=sharing",},

            {titulo: "📒[slides] Defining Relative Clauses Exercise 4",url: "https://drive.google.com/file/d/1_yyKTGRy0f-fcCZ5BlRsMZXsBb2usP3g/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 4 key",url: "https://drive.google.com/file/d/1ug8Ybq084KuS4AMXVRJ76pN1rbYs93cA/view?usp=sharing",},
            {titulo: "[Grammar Worksheet] WHO 1 ",url: "https://drive.google.com/file/d/1cFrsL8KTttdqE4BpsR2YGCU2BG_SrfSf/view?usp=sharing",},
            {titulo: "[Grammar Worksheet] WHO 2 ",url: "https://drive.google.com/file/d/1HnZWwulcMoWRBuPlkGff-2xxJ9rX0x56/view?usp=sharing",},

            {titulo: "[Grammar Worksheet] WHOSE",url: "https://drive.google.com/file/d/10p5K6lvpYpdtEIhJNy-redgQ7aLBnVb2/view?usp=sharing",},

            {titulo: "[Grammar Quizz] Relative Clauses",url: "https://drive.google.com/file/d/1DqU2kvUjrAuTRfIzDQkpmleUANeWxnjP/view?usp=sharing",},
            {titulo: "[Grammar Quizz] WHO vs WHOSE",url: "https://drive.google.com/file/d/1Ab3XGgBtb8XhgPRFY-9K91ddlu_cEtpG/view?usp=sharing",},
            {titulo: "RC001 - Relative Clauses",url: "https://drive.google.com/file/d/1K8WkdJTAuJvGBwZcksUylm4xKDiC_efC/view?usp=sharing",},
            {titulo: "RC002 - Relative Clauses - Combine the TWO Sentences",url: "https://drive.google.com/file/d/1OFQyjqF7p2ppuJmqu76GnH3RlL4lkKzM/view?usp=sharing",},
            {titulo: "RC003 - Relative Clauses - Combine the TWO Sentences",url: "https://drive.google.com/file/d/1u24eoljpLI0AB8ROkDi-HSTenUlAubrj/view?usp=sharing",},
            {titulo: "RC004 - Relative Pronouns",url: "https://drive.google.com/file/d/19zQQNKYKQ3j81ooeAS7CLiG8klHE_2Qn/view?usp=sharing",},
            {titulo: "RC005 - Relative Clauses - Combine the TWO Sentences",url: "https://drive.google.com/file/d/1JwHY1cfaESrUMr9Dby2Gt21sxHRtZ5t6/view?usp=sharing",},
           

         
            
            
        ],
    },
    {
        id: 15,
        thumbnail:
            "https://i.ibb.co/0XR5yjD/990527648dc1fe389bb8568a632839e8-removebg-preview.png",
        title: "M4 - English Verb Patterns",
        subtitle: "Basic Level",

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            { titulo: "📒[slides] Transitive and Intransitive Verbs",url: "https://drive.google.com/file/d/1q9Ay8KRUU9tSwuHEvjIM8bKZ3PWCyjkZ/view?usp=sharing", },
            { titulo: "📒[slides] Lista de Verbos Seguidos por Gerunds and Infinitives",url: "https://drive.google.com/file/d/1afE2D6xqPTMRPTfk3Vci97FXlR82GIdZ/view?usp=sharing", },

            { titulo: "📒[slides] Gerunds and Infinitives Explanation",url: "https://drive.google.com/file/d/1rE08bQrEyF0TVO7FTYWGtLaiOGKuLjRO/view?usp=sharing", },
            { titulo: "✍  Gerunds and Infinitives Exercise 1",url: "https://drive.google.com/file/d/1KJKLqjSwQeILyViRun9ADqge1ikKPmSD/view?usp=sharing", },
            { titulo: "✍  Gerunds and Infinitives Exercise 2",url: "https://drive.google.com/file/d/19WY1c2LJZrAjj84niwx-u5dgh-dafQb6/view?usp=sharing", },
            { titulo: "✍  Gerunds and Infinitives Exercise 3",url: "https://drive.google.com/file/d/1xURjjQPkur3dYBtFRuZTmbnqlC-ZCb2b/view?usp=sharing", },
            { titulo: "💡  GI003 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1H6BxX1OPZ-5fU7peCACnw6vRV5-lnUPW/view?usp=sharing", },
            { titulo: "🔑  GI003 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1OYpGW81Wt7dvLTsTa7zddJRJIKKo7Mpn/view?usp=sharing", },
            { titulo: "💡  GI004 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1GOe8JtMyfLpayGkIgkUn1IkGRblKsoGf/view?usp=sharing", },
            { titulo: "🔑  GI004 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1iAOBovzOkjJH9Z9rToPCj8losTuXz9ov/view?usp=sharing", },
            { titulo: "🧩  Desafio gerund vs infinitive",url: "https://wordwall.net/play/7240/772/7948", },
            { titulo: "🧩  Desafio gerund vs infinitive II",url: "https://wordwall.net/play/22920/270/462", },
            { titulo: "🧩  Desafio gerund vs infinitive III",url: "https://wordwall.net/play/76232/915/656", },
            { titulo: "🧩  Desafio gerund vs infinitive IV",url: "https://wordwall.net/play/71477/712/378", },
            { titulo: "🧩  Desafio gerund vs infinitive V",url: "https://wordwall.net/play/75464/667/869", },
            { titulo: "🧩  Desafio gerund vs infinitive VI ",url: "https://wordwall.net/play/59257/372/969", },
            { titulo: "🧩  Desafio gerund vs infinitive VII ",url: "https://wordwall.net/play/4838/285/4447", },

           
           



          
            {
                titulo: "📒[slides] UNIT 5:PRESENT PERFECT AND SIMPLE PAST",
                url: "https://docs.google.com/presentation/d/1bpMRMy7LVba68bhwB6w2KUEXmD7n-MAP/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },

            
        ],
    },
      {
        id: 16,
        thumbnail:
            "",
        title: "M4.1-PRESENT PERFECT PROGRESSIVE",
        subtitle: "Intermediate",

        dateAdded: "Basic 03",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
          
          
           
            {
                titulo: "📒[slides] UNIT 6:COMPARATIVE AND SUPERLATIVE ADVERBS",
                url: "https://docs.google.com/presentation/d/1SnYrDzmfRjdf8anu2jEpfWCPl0SiF3go/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            
            
            {
                titulo: "📒[slides] UNIT 8:EXPRESSING LIKES, DESIRES, AND PREFERENCES",
                url: "https://docs.google.com/presentation/d/19fs3RnfAEOjH5UFWASRrvTDXqXHSmv1l/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 8:GERUND PHRASES AS SUBJECT AND OBJECT",
                url: "https://docs.google.com/presentation/d/1HlSz01uARuBa4IJGUoFPFqTNXyYJQvG5/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 9:MAY, MIGHT, AND WILL FOR FUTURE POSSIBILITY",
                url: "https://docs.google.com/presentation/d/1PWQNyUECVcbCtSV0OkzvYJIP5YZdXP9c/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 9:WILL AND GOING TO",
                url: "https://docs.google.com/presentation/d/1p1cDpBXO3UfCBi_sBAfjxYFVsdhS0V9C/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 10:INFINITIVES OF PURPOSE",
                url: "https://docs.google.com/presentation/d/1_xVAxKXnDL0uX7Z9ewv0ehBi4glkWSno/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 10:REVIEW OF FUTURE FORMS",
                url: "https://docs.google.com/presentation/d/1aHJTp1D5LRb03PXqWOzVaytcFyqh_pWh/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 11:SIMPLE PRESENT PASSIVE",
                url: "https://docs.google.com/presentation/d/1b7T_AF8RaiIb06d8kEI5yfeJtovbNIYW/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 11:SIMPLE PAST PASSIVE",
                url: "https://docs.google.com/presentation/d/1KSbZiuL-5LJsxu0kssRgR4LP42URrpjd/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            
           

            
          
           
            
            {
                titulo: "Word formation nouns & adjectives",
                url: "https://wordwall.net/play/29190/295/941",
            },
           

            {
                titulo: "📒[slides] Past Simple Verb be",
                url: "https://docs.google.com/presentation/d/1WuALZwdoDRnIAVWE_WubIVTQBdUWaDD3/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            {
                titulo: "Present Perfect vs Present Perfect Continuous",
                url: "https://wordwall.net/play/10820/227/9928",
            },

            {
                titulo: "📒[slides] Sports play-do-go",
                url: "https://docs.google.com/presentation/d/101h3-ahYugj93t3qG9FMO3-vQUdpKE5b/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "Match up punctuation",
                url: "https://wordwall.net/play/54005/079/927",
            },
            {
                titulo: "PUNCTUATION MARKS AND SYMBOLS",
                url: "https://wordwall.net/play/39412/815/652",
            },
            {
                titulo: "Punctuation-Quiz 1",
                url: "https://wordwall.net/play/198/432/8119",
            },

            {
                titulo: "Punctuation-Quiz 2",
                url: "https://wordwall.net/play/056/784/4681",
            },
            {
                titulo: "Sensory Verbs",
                url: "https://wordwall.net/play/34047/429/899",
            },

            {
                titulo: "although, however, in spite of, despite",
                url: "https://wordwall.net/play/26923/219/206",
            },
           
            {
                titulo: "Present Perfect vs Present Perfect Continuous",
                url: "https://wordwall.net/play/10820/227/9928",
            },

            { titulo: "🦻Dictation 1", url: "https://youtu.be/ZwbyLBkLnKU" },
            {
                titulo: "📒[slides] Explanation Used to",
                url: "https://docs.google.com/presentation/d/1TDItudKkMsiBgTFP_vf8GRr3lsTXjpfW/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Explanation Comparison As...As",
                url: "https://docs.google.com/presentation/d/1rMdmtkVa39vMk8j2ol8tf4Y4kQ-0Xxg6/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            {
                titulo: "📒[slides] Modal Verbs of Necessity ",
                url: "https://docs.google.com/presentation/d/1yLoUCJ7980tV_LN3QC_W7FeCAa4gUsua/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "Present Perfect vs Present Perfect Continuous",
                url: "https://wordwall.net/play/10820/227/9928",
            },
           
            {
                titulo: "Present Perfect vs Present Perfect Continuous",
                url: "https://wordwall.net/play/10820/227/9928",
            },
            {
                titulo: "although, however, in spite of, despite",
                url: "https://wordwall.net/play/26923/219/206",
            },
            {
                titulo: "PRESENT PERFECT Exercises Grammar",
                url: "https://wordwall.net/play/20930/047/3447",
            },

            {
                titulo: "Since and for",
                url: "https://wordwall.net/play/22172/068/39116",
            },
            {
                titulo: "Present Perfect vs Present Perfect Continuous",
                url: "https://wordwall.net/play/10820/227/9928",
            },

            { titulo: "🦻Dictation 1", url: "https://youtu.be/ZwbyLBkLnKU" },
            {
                titulo: "📒[slides] Time clauses I ",
                url: "https://docs.google.com/presentation/d/1jRjvfeYY0pNPABCDi0F7TxPhRtgvf2rJ/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Similarity and agreement",
                url: "https://docs.google.com/presentation/d/1aA5Q9LqM9nIxfgJ_QXrXPLKHuZtx2beu/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            { titulo: "🦻Dictation 1", url: "https://youtu.be/ZwbyLBkLnKU" },
            {
                titulo: "📒[slides] Pronunciation",
                url: "https://docs.google.com/presentation/d/1wZROGjhm3VuujA7nl2XsweDnzeCV0TQK/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            {
                titulo: "📒[slides] Inverted Conditionals",
                url: "https://docs.google.com/presentation/d/10RUYwHbZ3d_GMwCUHtVJu-P-JAYoS5z_/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Inversion Explanation",
                url: "https://docs.google.com/presentation/d/1WdtHxR3xkgJA9OY8FJ1yYassPo6CIGVw/edit?usp=share_link&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            { titulo: "🗣️Simulacion Visa 1", url: "https://youtu.be/rMfG3rYSlh0" },
            { titulo: "🦻Dictation 1", url: "https://youtu.be/ZwbyLBkLnKU" },
            {
                titulo: "although, however, in spite of, despite",
                url: "https://wordwall.net/play/26923/219/206",
            },
            

            
           
            {
                titulo: "linkers of addition and contrast ",
                url: "https://wordwall.net/play/8219/371/327",
            },
            {
                titulo: "linkers of addition and contrast ",
                url: "https://wordwall.net/play/8219/371/327",
            },
        ],
    },

    {
        id: 27,
        thumbnail:
            "",
        title: "M7 -Advanced Structure",
        subtitle: "Upper-Intermediate",

        dateAdded: "B2",
        channel: "Upper-Intermediate",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
          
            
            {
                titulo: "📒[slides] UNIT 1: PRESENT PERFECT PROGRESSIVE",
                url: "https://docs.google.com/presentation/d/1FqSBQmJFZNO2J9n5wEfKEtQolqtEfwjv/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📝[test A] UNIT 1: Grammar and vocabulary PDF",
                url: "https://drive.google.com/file/d/1L55skpMyXpMfaYdK-6yiPbbRRi_vNPKa/view?usp=sharing",
            },
            {
                titulo: "📝[test A] UNIT 1: Grammar and vocabulary WORD",
                url: "https://docs.google.com/document/d/1qAHvstGrHBMUZtLFUfvkDTNTn_EnmLFT/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📝[test B] UNIT 1: Grammar and vocabulary PDF",
                url: "https://drive.google.com/file/d/1pxlAdQKDN4FgVQTvGyGASUpQEKjtMEYm/view?usp=sharing",
            },
            {
                titulo: "📝[test B] UNIT 1: Grammar and vocabulary WORD",
                url: "https://docs.google.com/document/d/1Ymc0Epm6ZmgFfY7CHSWcSdQ2aYcV6vJt/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📝[skill test] UNIT 1: Listening and writing PDF",
                url: "https://drive.google.com/file/d/1OEeWurlKS1ZyLyEpulrqzK5cLf_IZT5x/view?usp=sharing",
            },
            {
                titulo: "📝[skill test] UNIT 1: Listening and writing WORD",
                url: "https://docs.google.com/document/d/1guQo0Q-y3Aco5GDXw-gI1Mwu8QUM7ow2/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📽️[Video-Worksheet] Unit 1 Live and learn",
                url: "https://drive.google.com/file/d/1enqwoUPI9X2DsMFY9eChDFcMA7gdQYRR/view?usp=sharing",
            },
           
            
            {
                titulo: "📒[slides] USED TO ",
                url: "https://docs.google.com/presentation/d/1hjeM8uiiPSHFufWfJMxvbZpCndCN-2Mx/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] PAST PERFECT",
                url: "https://docs.google.com/presentation/d/1CRoJsRB9lUQ7wcOwYZ-X36vNNSC2azpV/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] DEFINITE ARTICLE THE/ ZERO ARTICLE ",
                url: "https://docs.google.com/presentation/d/1ZBSP1rFMLNbLTe5L2d3YypjHHHlz4wX2/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] INDIRECT QUESTIONS",
                url: "https://docs.google.com/presentation/d/10gHCV-87MTgk0ZZ52EJx4tccdINrVrKO/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] CAUSATIVE HAVE AND GET",
                url: "https://docs.google.com/presentation/d/1_3ahTLEy0-QeJ5oxKA0ns464-Q1h_grQ/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] ADJECTIVES ENDING IN –ED/–ING",
                url: "https://docs.google.com/presentation/d/1hm3JQyh9li96pP60B-ze_ao8iyuZh_pz/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] REPORTED SPEECH",
                url: "https://docs.google.com/presentation/d/1DYsVRlTghGCHSm4furCWTfgSRw1AyQvP/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] REPORTED QUESTIONS",
                url: "https://docs.google.com/presentation/d/1uHk_e865fl3aQ2hOAj0tn9CluY9ECNPO/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] THIRD CONDITIONAL",
                url: "https://docs.google.com/presentation/d/1uyQ6qwKGvw_gsli9GHbpawAtPMuVMtQX/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] HOPE AND WISH",
                url: "https://docs.google.com/presentation/d/1Z5q64p2CL0sbW4yNVZboFvGC4TRYUL13/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] MODALS OF DEDUCTION:MUST, CAN’T, MIGHT/MAY/COULD",
                url: "https://docs.google.com/presentation/d/1pSmzSB3VvxgMIN3qbrhxw7l3IRF2TZLN/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] TAG QUESTIONS",
                url: "https://docs.google.com/presentation/d/19LMGmlh76wTVirD9FpeWlUXW4df4gCtx/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] RELATIVE CLAUSES",
                url: "https://docs.google.com/presentation/d/1ktjlL9Ukjz8lbz2q7qeN5uH2cOxR16kz/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] VERB +GERUND/INFINITIVE",
                url: "https://docs.google.com/presentation/d/1JQDvauU0ttIP1M1Iqg9ZyOc4a4p4TA7A/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] INFINITIVE CLAUSES WITH IMPERSONAL IT",
                url: "https://docs.google.com/presentation/d/13Siio8SqdstUymNzgp3Gu4jXm2F5BKZF/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] WISH AND IF ONLY FOR REGRETS ",
                url: "https://docs.google.com/presentation/d/1WhyP0yVTi54ankXRvbVWQFYhMeiK1NMa/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] NON-DEFINING RELATIVE CLAUSES",
                url: "https://docs.google.com/presentation/d/1vFLgTr793gh3qUi339knm0ni_ILYPYTi/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] DEFINING RELATIVE CLAUSES",
                url: "https://docs.google.com/presentation/d/1znP8btGQWEZvO1VRSkBH-1gwp_oOhW44/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] SHOULD/SHOULDNT HAVE",
                url: "https://docs.google.com/presentation/d/1HU8mIm3lgulhGlGKHQFNjxg6ST9-azpk/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] WAS/WERE GOING TO AND WAS/WERE SUPPOSED TO",
                url: "https://docs.google.com/presentation/d/1tEdjjBe8-ipFATuc5IAFI9jsWoy2zZRp/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
           
        ],
    }, 
    
    
   {
        id: 18,
        thumbnail:
            "",
        title: "M4 - Phrasal Verbs",
        subtitle: "Pre-Intermediate",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
            

            {  titulo:"🗃️ Phrasal Verbs ",    url: "https://quizlet.com/838893013/match/embed?i=2oqoxh&x=1jj1"},
            {  titulo:"🗃️ Phrasal Verbs 2 ",    url: "https://quizlet.com/828300727/match/embed?i=2oqoxh&x=1jj1"},
            {  titulo:"🗃️ Phrasal Verbs 3 ",    url: "https://quizlet.com/573335887/match/embed?i=2oqoxh&x=1jj1"},
            {  titulo:"🗃️ Examen ",    url: "https://quizlet.com/test-questions/phrasal-verbs-and-meanings-bcb74e59-84c0-4969-a808-add21e028e4d?i=2oqoxh&x=1kqt&__overrideABs=FeatureAccess-practiceTests"},

            {titulo: "📒Phrasal verb with Get",url: "https://drive.google.com/file/d/1txaA2U2EMDVKnJ--_UM8YhzDZBaHasDP/view?usp=sharing",},
            {titulo: "📒Phrasal verb with Take",url: "https://drive.google.com/file/d/1ZkjaNFOku-6MgJSzH_QRRXHoYGm02uLQ/view?usp=sharing",},
            {titulo: "📒Phrasal verb Get vs Take",url: "https://drive.google.com/file/d/1XyP5ABzwxOESdOwnOucJ_2-3beKDqxwv/view?usp=sharing",},
            {titulo: "📒Phrasal verb with Up",url: "https://drive.google.com/file/d/1B7kiX_3JXK8jiRYNFkR4IxPqoHCz0J7K/view?usp=sharing",},
            {titulo: "📒Phrasal verb Dictation",url: "https://drive.google.com/file/d/1Q78yaqJPpqUThoLZ4y5tqPFp-x6eCV8F/view?usp=sharing",},


         
            
            
        ],
    },
    
    {
        id: 4,
        thumbnail: "https://i.ibb.co/Jwz8bgPJ/B2-FIRST-30.png",
        title: " Pronunciación Esencial I",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"🎬Presentacion", url: "https://youtu.be/dWDfFM88dSA"},
          
            {  titulo:"🎬 Mi primer truco de Pronunciación",url: "https://www.youtube.com/watch?v=gMlip7427kU&t=22s&ab_channel=MyEnglishBro"},           
            {  titulo:"📑 Mi primer truco de Pronunciación",url: "https://drive.google.com/file/d/1VhB8Kjr3YbARZU6KhPMvlPa0pZi92hX0/view?usp=sharing"},
            {  titulo:"🎬Diferencia de I/i", url: "https://www.youtube.com/watch?v=oMUO8eRSkXk"},

            {  titulo:"📑Diferencia de I/i", url: "https://drive.google.com/file/d/1M5_cODEz8FA51UDbOQ85Su9I5zKFOSCL/view?usp=sharing"},
            {  titulo:"📑Diferencia de /æ/, /ɑː/, y /ʌ/ ", url: "https://drive.google.com/file/d/1B1DI1uePifYoAs6EbQNYNvqz8dl4m9HU/view?usp=sharing"},
            {  titulo:"📑Th en Inglés de /θ/ y /ð/", url: "https://drive.google.com/file/d/1pPwuSgKPW9MNpN6TqFfjRZ__hw3W2wOK/view?usp=sharing"},

          
          
        ],
    },
    {
        id: 1,
        thumbnail: "https://i.ibb.co/Jwz8bgPJ/B2-FIRST-30.png",

        title: "Fundamentos I",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
            // {  titulo:"Welcome Unit",url: "https://drive.google.com/file/d/1qqZSEhaL0HcZRyKm5E_9j-ttnUNzxTFo/view?usp=sharing"},        

            
            {  titulo:"🎬Los Saludos",url: "https://www.youtube.com/watch?v=xipdKtlzxAg&t=435s"},           
            {  titulo:"[🗂️Infografía]Los Saludos ", url: "https://drive.google.com/file/d/1o8x7wvOmzrozDie2dizqliw7Eb5QGsw4/view?usp=sharing"},

            {  titulo:"🎬The Alphabet",url: "https://www.youtube.com/watch?v=fG9ccbmA0-o"},
            {  titulo:"[🗂️Infografía]The Alphabet ", url: "https://drive.google.com/file/d/10pTYkkB8ni0Ng3cxwv8mYuE7pQ6BF_Y-/view?usp=sharing"},

            {  titulo:"[🖥️Challenge] Spelling Names",url: "https://www.youtube.com/watch?v=NKZejheVK8w"},
            {  titulo:"[🖥️Solution] Spelling Names",url: "https://youtu.be/s-PqZNY9NIE"},
            {  titulo:"[🖥️Class] A/An Explicación",url: "https://youtu.be/6PHOdNLdjok"},
            {  titulo:"[🗂️Infografía] a/an  ", url: "https://drive.google.com/file/d/1MsMemHQtawat60xSxQFrWp3daZOLKJ3l/view?usp=sharing"},
            {  titulo:"🎬 12 Verbos Importantes en Ingles",url: "https://youtu.be/NuCWBUcvvaY"},
            {  titulo:"[🗂️Infografía] 12 Verbos Importantes en Ingles  ", url: "https://drive.google.com/file/d/1NGzis_cW6axVXqX5h7scYNn48FvZifrv/view?usp=sharing"},
            {  titulo:"🎬 Las Preposiciones",url: "https://youtu.be/8JEvVGC1HoQ"},
            {  titulo:"[🗂️Infografía] Las Preposiciones  ", url: "https://drive.google.com/file/d/1T2S3iq7ziQCr5CIDOdMrAd_zEQ0SkGYH/view?usp=sharing"},

            
           

        ],
    },
    {
        id: 4,
        thumbnail: "https://i.ibb.co/Jwz8bgPJ/B2-FIRST-30.png",
        title: "Vocabulario Esencial I",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
        
            {  titulo:"Las Frutas", url: "https://drive.google.com/file/d/1w2CwNRwhzm2zI7Wui33WHAiRWjPY74xl/view?usp=sharing"},
            {  titulo:"Los Números", url: "https://drive.google.com/file/d/1v8Llb28x3bJCDzuRgfDJXPOmqbRkMKuz/view?usp=sharing"},
            {  titulo:" Objetos de la casa ",url: "https://drive.google.com/file/d/1oJafOHW9rzR4-85EycQtGtZaDaHuIHdg/view?usp=sharing" },
            {  titulo:" Partes del Cuerpo",url: "https://drive.google.com/file/d/16M8ghnjnDxLr-IhhuCfhHPOK7aXUz6ac/view?usp=sharing" },
            {  titulo:" Lugares en Inglés",url: "https://drive.google.com/file/d/1zMMYEvI0nWXQZWpawErZ5J7OgnPf4rgO/view?usp=sharing" },
            {  titulo:" Los colores",url: "https://drive.google.com/file/d/18iiQLhwnGzGnfJQxnZrsBlt8YLyA38wz/view?usp=sharing" },
            {  titulo:" Los Animales",url: "https://drive.google.com/file/d/1hhtj5vmynyNva8Rx92O1yvR_7Wa0rPKb/view?usp=sharing" },

          
          
          
        ],
    },
    {
        id: 1,
        thumbnail: "https://i.ibb.co/Jwz8bgPJ/B2-FIRST-30.png",

        title: "Fundamentos II",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
            // {  titulo:"Welcome Unit",url: "https://drive.google.com/file/d/1qqZSEhaL0HcZRyKm5E_9j-ttnUNzxTFo/view?usp=sharing"},        

            
            
            {  titulo:"[🖥️Class] A/An Explicación",url: "https://youtu.be/6PHOdNLdjok"},
            {  titulo:"[🗂️Infografía] a/an  ", url: "https://drive.google.com/file/d/1MsMemHQtawat60xSxQFrWp3daZOLKJ3l/view?usp=sharing"},
            {  titulo:"🎬 12 Verbos Importantes en Ingles",url: "https://youtu.be/NuCWBUcvvaY"},
            {  titulo:"[🗂️Infografía] 12 Verbos Importantes en Ingles  ", url: "https://drive.google.com/file/d/1NGzis_cW6axVXqX5h7scYNn48FvZifrv/view?usp=sharing"},
            {  titulo:"🎬 Las Preposiciones",url: "https://youtu.be/8JEvVGC1HoQ"},
            {  titulo:"[🗂️Infografía] Las Preposiciones  ", url: "https://drive.google.com/file/d/1T2S3iq7ziQCr5CIDOdMrAd_zEQ0SkGYH/view?usp=sharing"},

            
           

        ],
    },
   
    {
        id: 4,
        thumbnail: "https://i.ibb.co/Jwz8bgPJ/B2-FIRST-30.png",
        title: "Trucos de Pronunciación ",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
           
            {
                titulo: "💣PRONUNCIACIÓN en INGLÉS (Presentación)👄",
                url: "https://www.youtube.com/watch?v=-YocPrBjydE&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&ab_channel=MyEnglishBro",
            },
            {
                titulo: "Trucos con la T",
                url: "https://www.youtube.com/watch?v=sh1-WReYeYY&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=2&ab_channel=MyEnglishBro",
            },
            {
                titulo: "Dropped T",
                url: "https://www.youtube.com/watch?v=MBPAI8TI-HA&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=3&ab_channel=MyEnglishBro",
            },
            {
                titulo: "T Flap",
                url: "https://www.youtube.com/watch?v=TAdE9TjixHk&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=4&ab_channel=MyEnglishBro",
            },
            {
                titulo: " Omission ",
                url: "https://www.youtube.com/watch?v=EbfroOu4_EU&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=5&ab_channel=MyEnglishBro",
            },
            {
                titulo: " T flap 2 ",
                url: "https://www.youtube.com/watch?v=8_-ABxzg3gE&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=6&ab_channel=MyEnglishBro",
            },
            {
                titulo: " T flap 3",
                url: "https://www.youtube.com/watch?v=w2BDLl5TVvA&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=7&ab_channel=MyEnglishBro",
            },
            {
                titulo: " T as Sh",
                url: "https://www.youtube.com/watch?v=VPFclhpx__s&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=8&ab_channel=MyEnglishBro",
            },
            {
                titulo: " Consideraciones al Pronunciar",
                url: "https://www.youtube.com/watch?v=717NdjUV9Po&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=9&ab_channel=MyEnglishBro",
            },
            {
                titulo: " T/D between 2 consonant sounds",
                url: "https://www.youtube.com/watch?v=vLUv888ckbk&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=10&ab_channel=MyEnglishBro",
            },
          
          
        ],
    },
   
   
    {
        id: 4,
        thumbnail: "https://i.ibb.co/Jwz8bgPJ/B2-FIRST-30.png",
        title: "Vocabulario Esencial II",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
        
            {  titulo:"Las Nacionalidades", url: "https://drive.google.com/file/d/1t-NO8pU0eJr-CqjYoeakkTnZOWB7odPw/view?usp=sharing"},
            {  titulo:"Días de la Semana", url: "https://drive.google.com/file/d/11JLBMEKHA5qK0hfzlsFI1SctOr7vSa47/view?usp=sharing"},
            {  titulo:"Los Adjetivos", url: "https://drive.google.com/file/d/1a4bQQNWNjxPwO82z4ztO51A0Nq2GhVVv/view?usp=sharing"},
            {  titulo:" Las estaciones ",url: "https://drive.google.com/file/d/1LGxrtVKrUYzgQfyNiaFGa2OhQG5WK2QL/view?usp=sharing" },
            {  titulo:" Las Profesiones ",url: "https://drive.google.com/file/d/1k9ve-mH0Ja3oN3P-S2fuEy93gnHgs49k/view?usp=sharing" },
            {  titulo:" Miembros de la familia",url: "https://drive.google.com/file/d/1cFE24uSHz39qd2F7QWD-A_Vr7I0GoD9P/view?usp=sharing" },

            {  titulo:"🗂️Slide] The Numbers and The Time", url: "https://docs.google.com/presentation/d/1lLVrkj4nl8wvv3aGmqasKH3Mioo09DE7/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true"},
           
            {  titulo:"[🧩 Activity]have got/has got", url: "https://wordwall.net/play/4935/754/2603"},

            {  titulo:"[🧩 Activity] The Time  I", url: "https://wordwall.net/play/11993/400/13264"},
            {
                titulo: "📒[slides] La hora en Ingles",
                url: "https://docs.google.com/presentation/d/1En8CAC9wcrXYWSawMEirZO7gU8tsAmBi/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
          
           
            {  titulo:"📖 Ordinal Numbers ",url: "https://drive.google.com/file/d/18I58jFyIcYY_apm1YTzXvv2TVuMVHnXk/view?usp=sharing" },


          
          
          
        ],
    },
    {
        id: 1,
        thumbnail: "https://i.ibb.co/Jwz8bgPJ/B2-FIRST-30.png",

        title: "Fundamentos II",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
           
            {  titulo:"[🧩 ] A/An Indefinite Articles ", url: "https://wordwall.net/play/25729/634/81869"},
            {  titulo:"🎬 Practicando A/An Indefinite Articles",url: "https://www.youtube.com/watch?v=oJHez43MOCM&ab_channel=MyEnglishBro"},
            {  titulo:"🎬 Los Plurales en Ingles",url: "https://youtu.be/acpprMF4NhY"},
            {  titulo:"[🗂️Infografía]Plurales ", url: "https://drive.google.com/file/d/1QeZ9rmMlgkaqHO5Dyfpmp7hk5pcZ7Uwy/view?usp=sharing"},

            {  titulo:"🎬 The English Structure ", url: "https://youtu.be/KHtBBCOnaKg"},
            {  titulo:"[🗂️Slide] The English Structure", url: "https://drive.google.com/file/d/1uhrnYQzPAG_dm2uXmfjew22pXEtNa-6S/view?usp=sharing"},
            {  titulo:"[🖥️Class] The Pronouns & Transformation", url: "https://www.youtube.com/watch?v=2Ty1I6hMq-g"},
            {  titulo:"[🖥️Class] The English Map", url: "https://www.youtube.com/watch?v=fOPkF348Kgg"},
           
           
            {  titulo:"📖Possessive", url: "https://docs.google.com/presentation/d/1UijMuEx-DdbZETXjEUUtT6IPkWF0az2w/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true"},
            {  titulo:"🧩Possessive Pronouns", url: "https://wordwall.net/play/52592/500/1753"},
           
           

        ],
    },
    {
        id: 4,
        thumbnail: "https://i.ibb.co/Jwz8bgPJ/B2-FIRST-30.png",
        title: "M1- Vocabulario Base",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"🗂️Slide] The Numbers and The Time", url: "https://docs.google.com/presentation/d/1lLVrkj4nl8wvv3aGmqasKH3Mioo09DE7/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true"},
            {  titulo:"[🧩 Activity]The Numbers", url: "https://wordwall.net/play/17273/376/89817"},
            {  titulo:"[🧩 Activity]The Numbers II", url: "https://wordwall.net/play/11115/711/5078"},
            {  titulo:"[🧩 Activity]The Numbers III", url: "https://wordwall.net/play/15640/307/5782"},
            {  titulo:"[🧩 Activity]have got/has got", url: "https://wordwall.net/play/4935/754/2603"},

            {  titulo:"[🧩 Activity] The Time  I", url: "https://wordwall.net/play/11993/400/13264"},
            {
                titulo: "📒[slides] La hora en Ingles",
                url: "https://docs.google.com/presentation/d/1En8CAC9wcrXYWSawMEirZO7gU8tsAmBi/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
          
           
            {  titulo:"📖 Ordinal Numbers ",url: "https://drive.google.com/file/d/18I58jFyIcYY_apm1YTzXvv2TVuMVHnXk/view?usp=sharing" },

          
            {  titulo:"📖 Seasons of the Year",url: "https://docs.google.com/presentation/d/1Ji0bSleS_268aZaK6RUvNEsB4dAK4mno/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true" },
            {  titulo:"🧩 Seasons of the Year",url: "https://wordwall.net/play/18524/265/35686" },
          
            {  titulo:"📖Countries/Nationalities + Extra grammar +Review Chart",url: "https://drive.google.com/file/d/12xOlTvoKpFlSGRJboWF1BvNsk4cqAixC/view?usp=sharing"},
            {
                titulo: "📒[slides] Jobs in English",
                url: "https://docs.google.com/presentation/d/1DjLkNdeShBKInTTdZOvwYUGrMHxu5h_q/edit?usp=share_link&ouid=114172849724389982127&rtpof=true&sd=true",
            },
          
            {  titulo:"📖 Professions",url: "https://docs.google.com/document/d/18WYvZntiIyTldbpPtcljy2bH27wKkud8/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true"},
        ],
    },
    {
        id: 1,
        thumbnail: "https://i.ibb.co/Jwz8bgPJ/B2-FIRST-30.png",

        title: "M1-Fundamentos",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
            {  titulo:"Presentación del Curso",url: "https://www.youtube.com/watch?v=_1DEJIOcJmY&t=2s"},        
            {  titulo:"Welcome Unit",url: "https://drive.google.com/file/d/1qqZSEhaL0HcZRyKm5E_9j-ttnUNzxTFo/view?usp=sharing"},        

            {  titulo:"🎬 Mi primer truco de Pronunciación",url: "https://www.youtube.com/watch?v=gMlip7427kU&t=22s&ab_channel=MyEnglishBro"},           
            {  titulo:"📥 Mi primer truco de Pronunciación",url: "https://drive.google.com/file/d/1VhB8Kjr3YbARZU6KhPMvlPa0pZi92hX0/view?usp=sharing"},
            {  titulo:"🎬Los Saludos",url: "https://www.youtube.com/watch?v=xipdKtlzxAg&t=435s"},           
            {  titulo:"[🗂️Infografía]Los Saludos ", url: "https://drive.google.com/file/d/1o8x7wvOmzrozDie2dizqliw7Eb5QGsw4/view?usp=sharing"},

            {  titulo:"🎬 Saludos y Despedidas",url: "https://docs.google.com/presentation/d/1QRZkXcYvHJFPhIMW7-7JdMKAtMmFQt2P/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true"},
            {  titulo:"🎬The Alphabet",url: "https://www.youtube.com/watch?v=fG9ccbmA0-o"},
            {  titulo:"[🗂️Infografía]The Alphabet ", url: "https://drive.google.com/file/d/10pTYkkB8ni0Ng3cxwv8mYuE7pQ6BF_Y-/view?usp=sharing"},

            {  titulo:"[🖥️Challenge] Spelling Names",url: "https://www.youtube.com/watch?v=NKZejheVK8w"},
            {  titulo:"[🖥️Solution] Spelling Names",url: "https://youtu.be/s-PqZNY9NIE"},
            {  titulo:"[🖥️Class] A/An Explicación",url: "https://youtu.be/6PHOdNLdjok"},
            {  titulo:"[🗂️Infografía] a/an  ", url: "https://drive.google.com/file/d/1MsMemHQtawat60xSxQFrWp3daZOLKJ3l/view?usp=sharing"},
            {  titulo:"🎬 12 Verbos Importantes en Ingles",url: "https://youtu.be/NuCWBUcvvaY"},
            {  titulo:"[🗂️Infografía] 12 Verbos Importantes en Ingles  ", url: "https://drive.google.com/file/d/1NGzis_cW6axVXqX5h7scYNn48FvZifrv/view?usp=sharing"},
            {  titulo:"🎬 Las Preposiciones",url: "https://youtu.be/8JEvVGC1HoQ"},
            {  titulo:"[🗂️Infografía] Las Preposiciones  ", url: "https://drive.google.com/file/d/1T2S3iq7ziQCr5CIDOdMrAd_zEQ0SkGYH/view?usp=sharing"},

            {  titulo:"[🧩 ] A/An Indefinite Articles ", url: "https://wordwall.net/play/25729/634/81869"},
            {  titulo:"🎬 Practicando A/An Indefinite Articles",url: "https://www.youtube.com/watch?v=oJHez43MOCM&ab_channel=MyEnglishBro"},
            {  titulo:"🎬 Los Plurales en Ingles",url: "https://youtu.be/acpprMF4NhY"},
            {  titulo:"[🗂️Infografía]Plurales ", url: "https://drive.google.com/file/d/1QeZ9rmMlgkaqHO5Dyfpmp7hk5pcZ7Uwy/view?usp=sharing"},

            {  titulo:"🎬 The English Structure ", url: "https://youtu.be/KHtBBCOnaKg"},
            {  titulo:"[🗂️Slide] The English Structure", url: "https://drive.google.com/file/d/1uhrnYQzPAG_dm2uXmfjew22pXEtNa-6S/view?usp=sharing"},
            {  titulo:"[🖥️Class] The Pronouns & Transformation", url: "https://www.youtube.com/watch?v=2Ty1I6hMq-g"},
            {  titulo:"[🖥️Class] The English Map", url: "https://www.youtube.com/watch?v=fOPkF348Kgg"},
           
           
            {  titulo:"📖Possessive", url: "https://docs.google.com/presentation/d/1UijMuEx-DdbZETXjEUUtT6IPkWF0az2w/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true"},
            {  titulo:"🧩Possessive Pronouns", url: "https://wordwall.net/play/52592/500/1753"},
           
           

        ],
    },
    {
        id: 1,
        thumbnail: "https://i.ibb.co/Jwz8bgPJ/B2-FIRST-30.png",
        title: "Materiales Sesiones",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
            {  titulo:"PDF Whats-your-name",url: "https://drive.google.com/file/d/1TrwJd_rR8u6DowclIEj9uKBfKUQ_WrKc/view?usp=sharing"},        
             {  titulo:"PDF I’ve got eleven cups!",url: "https://drive.google.com/file/d/1Etui1dFgH9aEkBYd8HO7Kr_MyIOP7_gq/view?usp=sharing"},        
             {  titulo:"PDF Welcome to my workspace!",url: "https://drive.google.com/file/d/11yKEHMHO5fa5m1vuDSz0CTLq34D0mxm8/view?usp=sharing"},        

            {  titulo:"PDF Theyre-my-friends-‘to-be-positive ",url: "https://drive.google.com/file/d/1tqyVnubHTN1Npv-fP4xKfh6JzgjqQq8Q/view?usp=sharing"},        
            {  titulo:"PDF My-bag-isnt-brown-‘to-be-negative ",url: "https://drive.google.com/file/d/1T3cFZeoYFgD_UeuL3exnSK2PHaohIoqv/view?usp=sharing"},        
            {  titulo:"PDF A day the life",url: "https://drive.google.com/file/d/1aslqgNDXiEcBOGYQsSaLycUFTh0K8lLU/view?usp=sharing"},
            {  titulo:"PDF Whats-the-weather-like ",url: "https://drive.google.com/file/d/13L1Mj3g4slfM7WbZVlZlwgJVk8dqLsRm/view?usp=sharing"},        
            {  titulo:"PDF Dress or jeans: clothes we wear ",url: "https://drive.google.com/file/d/10msh0Koi38v07LHOrED4KqzGV9GO_yGk/view?usp=sharing"},
            {  titulo:"PDF It’s his friends’ house (possessives) ",url: "https://drive.google.com/file/d/1BJPY5HTEw0BvPGOT8v5suFbULWJdUSUW/view?usp=sharing"},
            {  titulo:"PDF In my neighbourhood ",url: "https://drive.google.com/file/d/1OC_-CUH7HEgIcQLQkrqHT-7IiOVcSIxd/view?usp=sharing"},
            {  titulo:"PDF What’s your favourite food? ",url: "https://drive.google.com/file/d/1EwJgu9HfELp7PfyhaKPbDdEk622Gn-ax/view?usp=sharing"},
            {  titulo:"PDF For breakfast, I have… ",url: "https://drive.google.com/file/d/1w1e30nV1fzs1-mC2NdBW3JyCF8z0oq4J/view?usp=sharing"},


        ],
    },
    {
        id: 2,
        thumbnail: "https://i.ibb.co/Jwz8bgPJ/B2-FIRST-30.png",

        title: "Sesiones en Vivo",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
            {  titulo:"[🖥️Class] Clase 01 ",url: "https://youtu.be/n3ULyufFSzM"},        
            {  titulo:"[🖥️Class] Clase 02 ",url: "https://youtu.be/AgeIo-GQiRc"},        
            {  titulo:"[🖥️Class] Clase 03 ",url: "https://youtu.be/BPAX_Jmvgyg"},        
            {  titulo:"[🖥️Class] Clase 04 ",url: "https://youtu.be/MOa2KIVNOBM"},         
        ],
    },
   
    
   
    {
        id: 5,
        thumbnail: "https://i.ibb.co/Jwz8bgPJ/B2-FIRST-30.png",

           
            title: "M1-Present Tense I ",
        subtitle: "Basic Level",
    imagenseccion: "https://i.ibb.co/B6gr9Gd/Black-White-and-Red-Simple-Shield-Shape-Football-Club-Logo-2-removebg-preview.png",
      categoria:"speaking",
        dateAdded: "Basic 0 ",
        channel: "",
        description: "Curso básico de inglés para los que están empezando.",
        enlaces: [
            {  titulo:"[🖥️ Class] Prensent Simple with Be Afirmativo", url: "https://youtu.be/Qn3u8ixM4B8"},
            {  titulo:"[📊 Diagrama] Prensent Simple with Be Afirmativo", url: "https://drive.google.com/file/d/1y0DhY1JVNKt36a7-0ozVwmmUgkVMd_46/view?usp=sharing"},
            {  titulo:"[📑 GrammarSheet] Contractions with Be",url: "https://drive.google.com/file/d/1RbxiaSl1dFwOq7sFTF_7TRRmIpapN1XN/view?usp=sharing"},

            {  titulo:"[🧩 Activity] The Verb Be Affirmative Form I", url: "https://wordwall.net/play/13293/724/51767" },
            {  titulo:"[🧩 Activity] The Verb Be Affirmative Form II", url: "https://wordwall.net/play/14390/465/80013" },
            {  titulo:"[🧩 Activity] The Verb Be Affirmative Form III", url: "https://wordwall.net/play/11554/389/1088" },
            {  titulo:"[🖥️ Solution] Practicando el Verbo Be Affirmative Form", url: "https://youtu.be/Z9Y7IWFNX_Q"},
            {  titulo:"[📝 FunSheet] GRAMMAR ERROR CORRECTION BE",url: "https://drive.google.com/file/d/15RV8Qi_oXfnAjFGbZ2XE_MeZra8XPvot/view?usp=sharing"},
            {  titulo:"[🔖Practice]The Verb Be Affirmative Form",url: "https://drive.google.com/file/d/1fieorI4c7zCUt6ltKNrXlVX8aPXogvcb/view?usp=sharing" },
            {  titulo:"[🖥️ Class] Prensent Simple with Be Negative", url: "https://youtu.be/bBUUAjkC0Go"},
            {  titulo:"[📊 Diagrama] Prensent Simple with Be Negative", url: "https://drive.google.com/file/d/1CVydEJyBwS2X_9A_A4kRBleq_glgCopc/view?usp=sharing"},

            {  titulo:"[🔖Practice]The Verb Be Negative Form",url: "https://drive.google.com/file/d/15uWVRNGSUj0D8zZQ-O6K-UjTiArG5TA3/view?usp=sharing" },
            {  titulo:"[🖥️ Class] Prensent Simple with Be Interrogativa", url: "https://youtu.be/oWnUpDh-z9Y"},
            {  titulo:"[📊 Diagrama] Prensent Simple with Be Interrogative", url: "https://drive.google.com/file/d/1CVydEJyBwS2X_9A_A4kRBleq_glgCopc/view?usp=sharing"},

            {  titulo:"[🔖Practice]The Verb Be Yes/No Questions",url: "https://drive.google.com/file/d/1s7zZgtpqjsuc3i81bFhfj7PhUWrNoUX7/view?usp=sharing" },
            {  titulo:"[🔖Practice]The Verb Be Wh Questions ",url: "https://drive.google.com/file/d/1MFejzFjYgHoSPlsoNQLF07R4-y107XcC/view?usp=sharing" },
            {  titulo:"[🔖Practice]The Verb Be Mixed I ",url: "https://drive.google.com/file/d/1NVzc8Cl78PSxJfxwJJQCb4JH8EKcpVKT/view?usp=sharing" },
            {  titulo:"[🔖Practice]The Verb Be Mixed II ",url: "https://drive.google.com/file/d/1qqvXwkB_yUCHU4nAOaItjenf8AwaBy6p/view?usp=sharing" },
            {  titulo:"[🖥️ Class] Adjectives", url: "https://youtu.be/CpG5KE79gFg"},
            {  titulo:"[🗂️Slide] Adjectives",url: "https://docs.google.com/presentation/d/1kfRo9rtah5D8Afgsj8zbV5iC1c1pOPju/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true"},
            {  titulo:"[🧩 Activity] The Verb Be Negative Form", url: "https://wordwall.net/play/21158/025/3896" },
            {  titulo:"[📝 FunSheet] BE VERB: Negative",url: "https://drive.google.com/file/d/1Y5UlRlzuV3TLR79_IutdZYshmYs23cIf/view?usp=sharing"},

            {  titulo:"[🧩 Activity] The Verb Be Interrogative Form I", url: "https://wordwall.net/play/1856/077/57902" },
            {  titulo:"[🧩 Activity] The Verb Be Interrogative Form II", url: "https://wordwall.net/play/58086/380/593" },
            {  titulo:"[🖥️ Solution] Practicando el Verbo Be Negative & Interrogative Form", url: "https://youtu.be/L0yrUtFO1pE"},
            {  titulo:"📖 Grammar Discussion  Verb be", url: "https://drive.google.com/file/d/1TT9jj4dJ_ylAh64LjBYe8Gjq4GzOOjxg/view?usp=sharing"},
            {  titulo:"📖 Grammar Discussion  Verb be", url: "https://drive.google.com/file/d/1TT9jj4dJ_ylAh64LjBYe8Gjq4GzOOjxg/view?usp=sharing"},

            {  titulo:"📖 The Verb Be Negative and Interrogative Form", url: "https://docs.google.com/presentation/d/1-37e0Rj12xLoLJ8AIadt47Q0q-D8JbkR/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true"},
            {  titulo:"📃The Verb Be Affirmative Form",url: "https://drive.google.com/file/d/1rTn31H9zJcXSRVNm1MGJ-se_3PFChW_N/view?usp=sharing" },

            {  titulo:"📖  Be-WH Questions", url: "https://docs.google.com/presentation/d/1QzcM-95Md4pWWy1d6BzM2CX2klPaPbXT/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true"},
            {  titulo:"📖Correct the Sentences with The Verb Be in Questions",url: "https://docs.google.com/presentation/d/1PmPGCCydt73O4vXTB9ThQdiMk-zSdZs0/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",},
            { titulo: "💡🎦 Present Tense Simple Be 01  ",url: "https://drive.google.com/file/d/1O2eE2VUMwZLRuFiDaTvjE-zTIj15DP-h/view?usp=sharing", },

            {  titulo:"📖 Review Verb be ",url: "https://docs.google.com/presentation/d/1Ckb4LISBB35qHq5Yxf1sPEruLXAo-o6w/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true" },
            {  titulo:"[😎Slide] Speak Like a Native 01", url: "https://docs.google.com/presentation/d/17nnI3AdqbUoFzVws8KmozupnKy7K1VgU/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true"},
            {  titulo:"[🖥️ Class] Plural Nouns", url: "https://youtu.be/K2v046W9AoE"},

            
            
            {  titulo:"[🗂️Slide] Plural Nouns", url: "https://docs.google.com/presentation/d/1uGlaHgl2gR_LI3_Z9wZzlp99FmqRvZAp/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true"},


            {  titulo:"[🖥️ Class] Practicando Plural Nouns", url: "https://youtu.be/K2v046W9AoE"},

            {  titulo:"[🧩 Activity] Plural Nouns Rules", url: "https://wordwall.net/play/75502/816/809" },
            {  titulo:"[🖥️ Class] Demonstrative Adjectives", url: "https://youtu.be/K2v046W9AoE"},

            {  titulo:"[🗂️Slide] Demonstrative Adjectives ",url: "https://docs.google.com/presentation/d/1hw4LZ3Tma1QFhHUwTdENPHhRcvaE9Rdv/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true",},
            {  titulo:"[🖥️ Class] Demonstrative Pronouns", url: "https://youtu.be/K2v046W9AoE"},

            {  titulo:"[🗂️Slide] Demonstrative Pronouns ",url: "https://docs.google.com/presentation/d/18Y9eWTC4cdzK1L3EEFhNz7OFCtKjWIFh/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true",},

           
            {
                titulo: "📒[slides] Making Suggestions Lets and Could",
                url: "https://docs.google.com/presentation/d/152lX6FIORqoOI59MOv28XNZ4CoxZNMEh/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Prepositions of Time",
                url: "https://docs.google.com/presentation/d/1aWoKAeyUeC6kUluXaBHWZhKoC2li7KLN/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
           
          
           
          
            {  titulo:"✍️Practica Integradora 1", url: "https://docs.google.com/document/d/1dEid7CxmlAwFluGbugI-3zH__ktx_KrV/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true", },



            
        ],
    },
   
   
    
    
    
    {
        id: 6,
        thumbnail:
            "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEi6xRIByLoBqwDhdCsBh8XvNrZvOnQ3o7i3vYfWeSz4gGKzcyqTCqLYixUAJr-l5U3jOOZWECk21ITxO4iV44_3QzaTw3SIVjSt9Gmbm82EBF4TBZ4-CZKuC16GL0bTLxHSsmRln8lcxFLz/s800/bg_snow_school.jpg",
        title: "M1 - Present Simple II ",
        subtitle: "A1 - Present Progressive Tense",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos los concepto elemental en el idiomrir las habilidades necesarias para avanzar a niveles más altos de competencia en el futuro. ",
        enlaces: [
          

            {  titulo:"📖 Prepositions", url: "https://docs.google.com/presentation/d/1whWilz_x5_6fQ9uQ0_2jmEQulZmuSoMi_y_6X3HLmqY/edit?usp=sharing"},
            {  titulo:"📖 Professions",url: "https://docs.google.com/document/d/18WYvZntiIyTldbpPtcljy2bH27wKkud8/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true"},
            {  titulo:"[🖥️ Class] Present Simple con todos los verbos Afirmativo", url: "https://youtu.be/ZgqOqJMP6ec"},
            {  titulo:"[📊 Diagrama] Prensent Simple Affirmative", url: "https://drive.google.com/file/d/1fQLm5OLOa4PeRXDrsgl73M1EY9Yno7_F/view?usp=sharing"},

            {  titulo:"[🗂️Slide] Present Simple Tense Affirmative ",url: "https://docs.google.com/presentation/d/1hWVK_6KkwKxRtWJtx0TL-A4K5oPMdUQJ/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true" },
            {  titulo:"[🧩 Activity] 3rd Person Rules",url: "https://wordwall.net/play/28761/823/4170" },
            {  titulo:"[🧩 Activity] Present Simple  Affirmative Form",url: "https://wordwall.net/play/57830/431/8032" },
            {  titulo:"[🔖Practice] Spelling Changes",url: "https://drive.google.com/file/d/1dpWuDqqkIR8au1C1PERB6pOz5H-ivktU/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Affirmative Form I",url: "https://drive.google.com/file/d/1gn1jk2vGP960VU-D_9IU9QknhCfDbLQ_/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Affirmative Form II",url: "https://drive.google.com/file/d/1RMuY04Q492JcJOO8goK8-JQp9kLktCYK/view?usp=sharing" },
            {  titulo:"[🧩 Activity] Days of the week ", url: "https://wordwall.net/play/22419/293/58122"},
            {  titulo:"[🖥️ Class] Present Simple con todos los verbos Negative", url: "https://youtu.be/AmHTz5A-8Cs"},
            {  titulo:"[📊 Diagrama] Prensent Simple Negative", url: "https://drive.google.com/file/d/1qn3gmgoev23lc4lFZlYHq5q-skIlsyYA/view?usp=sharing"},

            {  titulo:"[🔖Practice] Present Simple Negative Form I",url: "https://drive.google.com/file/d/1dvhm4IVAk_jXGiq86I0i6lBxZzLlA7v-/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Negative Form II",url: "https://drive.google.com/file/d/1BCabvvBOmmIuh6lD5XRMWwch1l0oP-54/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Yes/No Question ",url: "https://drive.google.com/file/d/1buU-xEfNvhliFhUqmIMQrKWAnPDCXlU7/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Wh Question ",url: "https://drive.google.com/file/d/1fCLeWwtj35ziI_NLborQ2Mo1swL-m_rU/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Mixed I  ",url: "https://drive.google.com/file/d/1wS1NV6i_XfNKTVSEDyIX-BJ3xkkgfmwX/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Mixed II  ",url: "https://drive.google.com/file/d/1dbIdnY51wBQl5SxyYuqxVQF2GqioLRlt/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Mixed III  ",url: "https://drive.google.com/file/d/1SXoJvjOeeYoEbPv1-9JrSCZvJWMiorgB/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Mixed IV  ",url: "https://drive.google.com/file/d/1F6rawDVqTKM8NiTxMWDmNVxGIHKALDRx/view?usp=sharing" },
            { titulo: "💡🎦 Present Tense Simple 01  ",url: "https://drive.google.com/file/d/16-zgiVH0dbaoa7GqXz7gNfAQSXOOx7zl/view?usp=sharing", },
            { titulo: "💡🎦 Present Tense Simple 02  ",url: "https://drive.google.com/file/d/1UDHSqaN1269ZYDfTaet2_Cd8X2SlE-_f/view?usp=sharing", },
            { titulo: "💡🎦 Present Tense Simple 03  ",url: "https://drive.google.com/file/d/1zoXjEjhdZfGh35xQUsVQDFhBk5misIq0/view?usp=sharing", },

            {  titulo:"🚩 Listening Quiz", url: "https://forms.gle/6GitkPaDLfMyah3n7"},

            {  titulo:"📖 Possesive Adjectives", url: "https://docs.google.com/presentation/d/1zkn5eJjUJTDUUjOU45ZZIRu8-7c9saPO/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true" },
            {  titulo:"🧩Possesive Adjectives", url: "https://wordwall.net/play/55417/749/2837" },
            {  titulo:"🧩Possesive Adjectives I", url: "https://wordwall.net/play/18888/235/2402" },
            {  titulo:"📖 Possessive", url: "https://docs.google.com/presentation/d/1UijMuEx-DdbZETXjEUUtT6IPkWF0az2w/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true"},
            {  titulo:"🧩 Possessive Pronouns", url: "https://wordwall.net/play/52592/500/1753"},
            {  titulo:"📖 Object Pronouns ",url: "https://docs.google.com/presentation/d/1uF-fBeTnLSjeRJULZT-cxo1DHRiJBBidBqeyBhWxrh0/edit?usp=sharinghttps://docs.google.com/presentation/d/1uF-fBeTnLSjeRJULZT-cxo1DHRiJBBidBqeyBhWxrh0/edit?usp=sharing" },
            {  titulo:"🧩 Object Pronouns ", url: "https://wordwall.net/play/69980/389/917"},
            {  titulo:"🧩 Object Pronouns I", url: "https://wordwall.net/play/58591/627/3167"},
            {  titulo:"🚩 Reading Quiz", url: "https://forms.gle/dJmmufZ977WmRkN37"},
            {  titulo:"🚩 Reading Quiz ", url: "https://forms.gle/82QXSxvtB6BSPHLc8"},
            {  titulo:"☠️ Check Point 01",url: "https://drive.google.com/file/d/14hNicd6J5TxO0dILuMFwg85A8dmW7WTC/view?usp=sharing" },
            { titulo: "📖Explanation Adverbs of Frequency",url: "https://docs.google.com/presentation/d/12feKDZwOqILPrUSp6Nm6vtYqfcgjaQqR/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true", },
            { titulo: "📖FREQUENCY ADVERBS AND ADVERBIAL PHRASES",url: "https://docs.google.com/presentation/d/16-wwNO2lpWVdp222T5v6qAx2Y84QG0RC/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",},
            { titulo: "📖Explanation Adverbs of Frequency", url: "https://docs.google.com/presentation/d/12feKDZwOqILPrUSp6Nm6vtYqfcgjaQqR/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",},
            {  titulo:"🧩Adverbs of Frequency", url: "https://wordwall.net/play/54781/327/2832"},
            { titulo: "📖Imperatives",url: "https://docs.google.com/presentation/d/1IBGfgt3RbQSgNHUolh8T0JyXjv4NfvLS/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",},
            { titulo: "📖THE IMPERATIVE",url: "https://docs.google.com/presentation/d/1zecWMqAGGTYW3Ogmm7hSF44xZitwTedl/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",},
            {  titulo:"🧩Imperatives",url: "https://wordwall.net/play/16378/903/4549" },

           
            {
                titulo: "📒[slides] Possessive Nouns",
                url: "https://docs.google.com/presentation/d/1bLZnrTpjyce03zBK452iwIl22MscWXAb/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Vocabulary Family",
                url: "https://docs.google.com/presentation/d/1vLAkUKANVHp8qr4HqaPaEeURLruLyKxx/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            
            {
                titulo: "📒[slides] Too Vs Very ",
                url: "https://docs.google.com/presentation/d/1a6l6h79USa5zWCE39sn0VywhX0dKBJE1/edit?usp=share_link&ouid=114172849724389982127&rtpof=true&sd=true",
            },


            {
                titulo: "📒[slides] Questions with like -Personality Adjectives",
                url: "https://docs.google.com/presentation/d/1h-RZyzVXhOj7DIGmZ0EYFz9hmJB8obSa/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            {  titulo:"25-📒[slides] Can vs Can't", url: "https://docs.google.com/presentation/d/1whWilz_x5_6fQ9uQ0_2jmEQulZmuSoMi_y_6X3HLmqY/edit?usp=sharing"},
           

            { titulo: "📝[skill test] UNIT 1: Listening and writing PDF",
                url: "https://drive.google.com/file/d/1lj6qtiswWIwvf0zSVne5b8dPEv3S3ra1/view?usp=sharing",
            },

            {  titulo:"06-📝[Challenge exam ] Check Point 02",url: "https://drive.google.com/file/d/10lHkTSgsdcwQ_hGKRztslK4vyiBlWX1_/view?usp=sharing" },
            {  titulo:"06-📝[Challenge exam ] Check Point 03",url: "https://drive.google.com/file/d/1zLH90bW_pMCL9HcUZto5c7Wqa_EyCBrc/view?usp=sharing" },

            {  titulo:"06-📝[Challenge exam ] Check Point 04",url: "https://drive.google.com/file/d/1EnoW42XNEawjftA1bKSeH0oJo9G3AHzB/view?usp=sharing" },

            {  titulo:"06-📝[Challenge exam ] Check Point 05",url: "https://drive.google.com/file/d/1ENHYzaj58usqyUFChs8ELBhDeeyITtJG/view?usp=sharing" },

            {  titulo:"06-📝[Challenge exam ] Check Point 06",url: "https://drive.google.com/file/d/1AVOmfvSbOUPPtc0d77y9YzM9yqsAXHMn/view?usp=sharing" },

            {  titulo:"06-📝[Challenge exam ] Check Point 07",url: "https://drive.google.com/file/d/1-qNBFmBf47x3qF6D8MNIQ626KtKAVbWQ/view?usp=sharing" },

            {  titulo:"06-📝[Challenge exam ] Check Point 08",url: "https://drive.google.com/file/d/1pJF_hC6nWNLc0UKcFFj44LO2LA1SkYtC/view?usp=sharing" },

            {  titulo:"06-📝[Challenge exam ] Check Point 09",url: "https://drive.google.com/file/d/1SPObWytxTPSAtog2ajYgo2YjAboLXKL5/view?usp=sharing" },

            {  titulo:"06-📝[Challenge exam ] Check Point 10",url: "https://drive.google.com/file/d/1FF4Ej6LblNh2l9uBSb1m3L7AfshaY418/view?usp=sharing" },

            {
                titulo: "📝[skill test] UNIT 1: Listening and writing WORD",
                url: "https://docs.google.com/document/d/1QYUOyZK6w3-IFXYP-Kojg-ezBrNQQf1f/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "🔊🦻[skill test]AUDIO TRACK",
                url: "https://drive.google.com/file/d/1yG1XxPQKV8wxNdkSb5EinETT5g1_GZGD/view?usp=sharing",
            },
            {
                titulo: "📽️[Video-Worksheet] Unit 1 Nice to meet you",
                url: "https://drive.google.com/file/d/1iIEtN9QL8NJIMZOTS75pJPO1OsyveWxd/view?usp=sharing",
            },
            
           
          
            
            {
                titulo: "📒[slides] UNIT 4:CLAUSES WITH UNTIL, BEFORE, AFTER",
                url: "https://docs.google.com/presentation/d/1ThbilTcaiDU8Qyts6iz3Oxx8uOnC9_ki/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            
           
            
          
            
            {
                titulo: "📒[slides] UNIT 7:CAN/CAN’T—ABILITY",
                url: "https://docs.google.com/presentation/d/1MblKTYMvUxtStvDA4DF75g8Y0fc3tEbZ/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 7:ADVERBS OF MANNER",
                url: "https://docs.google.com/presentation/d/1u8sgSerVcr47Mjm3dp9e6c0oa5oq55pL/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
           
           
           
            {
                titulo: "📒[slides] UNIT 9:VERB PHRASES ",
                url: "https://docs.google.com/presentation/d/1FHariJeOWfNHEd7J6BfbI9b2guiorCcU/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
          
          
            {
                titulo: "📒[slides] UNIT 11:DIRECT AND INDIRECT OBJECTS",
                url: "https://docs.google.com/presentation/d/1invT5oXLeCWs3ZoBJ63VqNDUsxtVwws3/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
           
           
            { titulo: "💡🎦 Present Progressive   01  ",url: "https://drive.google.com/file/d/1HetObvFCgAXNetY0dTPvLJzT2hreurco/view?usp=sharing", },

            
          
           
           
            
        ],
    },
    {
        id: 5,
        thumbnail:
            "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEil5OltjehcYor12MEQAojBH31zPiKXE_pKkm4kCKAwmzeliGhNcKEZvpEgnqithyphenhyphenLwZytA5WlaHr7SYDYfF5GY1j4lIYwheDgYIKX1nY1ay2DnvjTpbvWy42tkxeuwzK_6sPj_WWqDgmEA/w1200-h630-p-k-no-nu/bg_school.jpg",
        title: "M1-Listening Center ",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
           
            {  titulo:"[ ▶️💿 Listening Track] Be-Verbs-Introduction", url: "https://drive.google.com/file/d/17Lf7YVWWL3J6ZlxcBGo_uKJLeN3aeClc/view?usp=sharing"},
            {  titulo:"[ 🎧📑 Listening Worksheet] Be-Verbs-Introduction", url: "https://drive.google.com/file/d/1KfV3ia7U0wgt0w382Xfu4wgKgvSG7oDB/view?usp=sharing"},
            {  titulo:"[ ▶️💿 Listening Track] Be-Yes-No-Questions", url: "https://drive.google.com/file/d/1QdV0ezdTMqw_-XY6EQhbU7XWtIbDBfLT/view?usp=sharing"},
            {  titulo:"[ 🎧📑 Listening Worksheet] Be-Yes-No-Questions", url: "https://drive.google.com/file/d/1sRDMHlTvic6YDluhWQ3vJmwFIxodWFee/view?usp=sharing"},
            {  titulo:"[ ▶️💿 Listening Track] Likes-Fruits", url: "https://drive.google.com/file/d/1jK724U6fY7fsfH49MMp_P5aeI9WxKWSO/view?usp=sharing"},
            {  titulo:"[ 🎧📑 Listening Worksheet] Likes-Fruits", url: "https://drive.google.com/file/d/1neV1tlIP3aw7wCvfiOcAcAdZkYP8P1pU/view?usp=sharing"},


            {  titulo:"[ ▶️💿 Listening Track] Verbs -Present Simple", url: "https://drive.google.com/file/d/1E3LHvSXWGIWD_VlvFiZU_SPGrYRQI2qp/view?usp=sharing"},
            {  titulo:"[ 🎧📑 Listening Worksheet] Verbs -Present Simple", url: "https://drive.google.com/file/d/1_UQf3VANxdA62__5oBLnngJSYhmnTx5L/view?usp=sharing"},

            {  titulo:"[ ▶️💿 Listening Track] Yes / No Questions with Verbs", url: "https://drive.google.com/file/d/1sQ5GIqQPAepKqpzAI8X8IwZFkUn54xYY/view?usp=sharing"},
            {  titulo:"[ 🎧📑 Listening Worksheet] Yes / No Questions with Verbs", url: "https://drive.google.com/file/d/1dyB2TOcY9wN-LnoCSpqbDUqTTfhPyDiu/view?usp=sharing"},

            {  titulo:"[ ▶️💿 Listening Track] Third Person Singular", url: "https://drive.google.com/file/d/1dpZcurygltj5nPjHC5f-M-Nm9az0mEFJ/view?usp=sharing"},
            {  titulo:"[ 🎧📑 Listening Worksheet] Third Person Singular", url: "https://drive.google.com/file/d/1b1Ne9hLfpUDTI7ahvrwtCIfAkiPiXI4C/view?usp=sharing"},


            {  titulo:"[ ▶️💿 Listening Track] Adjectives", url: "https://drive.google.com/file/d/1eP9vlMcWY5rQeElEyMwMRc9no7JKucgN/view?usp=sharing"},
          
            {  titulo:"[ 🎧📑 Listening Worksheet] Adjectives", url: "https://drive.google.com/file/d/1bPduv45i_ih-KU2dt9M7QUpXnFluwPMz/view?usp=sharing"},
      
      
            {  titulo:"[ ▶️💿 Listening Track] Days of the week", url: "https://drive.google.com/file/d/1S8LCubZ3TTG_b77lhxpln4TPJ7SaOTCr/view?usp=sharing"},
            {  titulo:"[ 🎧📑 Listening Worksheet] Days of the week", url: "https://drive.google.com/file/d/19lQ7wqAtffFMAS2Bs9opcn8GJ9f2_Gew/view?usp=sharing"},
      
      
        ],
    },
    {
        id: 7,
        thumbnail:
            "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjBFt5gII2wJI0hvuZmP8SncLkWCe81wqbiL9D5CvMetShyphenhyphenFaCqdbstIGJ2x-G8HQSQBVk-KCVwMS2hx7zH6qioyTcMGee2pqze_Vt4Ck3WnvYinWBLbjXWCL1PrUBlb9NpKKBxZXzwl67w/s1600/bg_school_koutei.jpg",
        title: "M1- Present Simple vs Progressive",
        subtitle: "Pre-Intermediate",

        dateAdded: "Basic 09 ",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
            {
                titulo: "📒[slides] Explanation Non Action Verbs",
                url: "https://docs.google.com/presentation/d/1iRId98sfwylaVNdIwLgAp1fTvSyFxzQw/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "🎯 Stative Verbs Group Exercise",
                url: "https://wordwall.net/play/34083/656/824",
            },
            {
                titulo: "🎯 Stative Verbs vs Dynamic Verbs 1",
                url: "https://wordwall.net/play/35891/342/229",
            },
            {
                titulo: "🎯 Stative Verbs vs Dynamic Verbs 2",
                url: "https://wordwall.net/play/29172/527/2575",
            },
            { titulo: "💡🎦 Present Tense Simple and Progressive 01 ",url: "https://drive.google.com/file/d/1nfWk8xLzG10nr3XrKVC3bpX5w00jN81P/view?usp=sharing", },

            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/19FdH7nnsqL0Ez9siyiFv3PCEvt4EknFv/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1HRBxbp2b_5kcObTcgjMDmRKXH-xW0O4M/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1aAeXIW3wmnJwJjUTcCE6m7PV9aElcgeB/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1ugupTJWoGVpoH7q_UxAivmklT21IBsKv/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1HlMPxx9G-eXDvAkpnoYcD_qhH8DRcUt_/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1fQ23Xn4bXCSZJSaHGiWf5utUXeHAK0ma/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1Gjn3DIa6xRDKcbKFvUopOvzMTA7vnW02/view?usp=sharing", },
            {titulo: "📒[slides] Simple present /  Present progressive",url: "https://docs.google.com/presentation/d/1aGIUs6OxD2chdWfcU7HACie_D64bc3vy3NE_OB-2Ztw/edit?usp=sharing", },

            
            {titulo: "📒[slides] Present progressive for future",url: "https://docs.google.com/presentation/d/127VXd9ZK8i7BItgdXOik5VSWc9_G7dWRn7sMEbaFEUI/edit?usp=sharing",},

            {titulo: "📒[slides] Compounds: every",url: "https://docs.google.com/presentation/d/1RmaKN7jY5ej_nCVRgFSTI1b0tCMPx7IqZxLbHvDuK_E/edit?usp=sharing",},
           
            
            {titulo: "📒[slides] Comparative adjectives",url: "https://docs.google.com/presentation/d/1UwvUgRFxdCDPk648imeb3G9_V3rQ58e7UpvL7iD62lw/edit?usp=sharing", },
            {titulo: "📒[slides] Superlative adjectives", url: "https://docs.google.com/presentation/d/1EGA1g6Wx7aQTZYGeXUkK_PDeF3CXNLcU-sFWuhpxAmQ/edit?usp=sharing",},
            { titulo: "📒[slides] Verb + -ing form / infinitive", url: "https://docs.google.com/presentation/d/1V9GjtW5BRs2n4knhrQfQbeHkvLnJPP7tUTCmokQzeBQ/edit?usp=sharing",},

           
            {
                titulo: "📒[slides]Food in English + Describing food in English",
                url: "https://docs.google.com/presentation/d/1ea3d6wBVgcjuOsMoq3_nAuI-ZT9SrIxa/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
           
            {
                titulo: "📒[slides] Vocabulary-At the Restaurant 1 ",
                url: "https://docs.google.com/presentation/d/1Hw5NLZdI9y9rruKi--qHDiFxcCH07WYp/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            {
                titulo: "Conversation At the Restaurant 1 ",
                url: "https://docs.google.com/presentation/d/174rPUtaLiCPNGmHnYgK-LEgdubJOQtoS/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

           
        ],
    },
    {
        id: 9,
        thumbnail:
            "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh4dgy-i-_5wh7YnYNUp5wWWSlNnQ3ArnLgUgdZxpYAH0cw3xCHLdAf-e802srSl-8aCQm2O3FYmYXET7yDmP-JOLFeuhaIlhaMhJXLX6V7yDRv4R4t7Y89VVseZ3Nj88HThM0aSsbm5U0/w1200-h630-p-k-no-nu/school_taiikukan2.png",
        title: "M1-Nouns",
        subtitle: "Basic Level",
     

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            {  titulo:"🧩 There is/ There are",url: "https://wordwall.net/play/19158/687/83046"},
            {  titulo:"🧩 There is/ There are II ",url: "https://wordwall.net/play/21498/511/4430"},
            {  titulo:"🚩Writing Quiz  ", url: "https://forms.gle/QgiGFeXaXpEvaatU8"},
            {titulo:"📖 THERE IS / THERE ARE WITH SOME, ANY, SEVERAL, A LOT OF, MANY", url: "https://docs.google.com/presentation/d/1VwIJNGPfNm_3lmEpUoCDWMUtH7c1rEs7/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",},
            {titulo: "📖 Count / noncount nouns  some / any",url: "https://docs.google.com/presentation/d/1jH6YT2V1nqUZlZg87_nz2tL7dOuTOGubcKf5Wx2afc8/edit?usp=sharing",},
            {titulo: "📖 Compounds:  some / any / no",url: "https://docs.google.com/presentation/d/1tj-HacwRg_cFagev4icmdnngHJKihkozJZKF7YdSI1o/edit?usp=sharing", },
            { titulo: "📖 a lot of / much / many / How much …? /  How many …?",url: "https://docs.google.com/presentation/d/1-X6kwm4EcY28fchr9KjrksLA_bo0NW_REx2ulLewyik/edit?usp=sharing", },
            {titulo: "📖 a little / a few",url: "https://docs.google.com/presentation/d/1rR9yhIV9RjF_zUQe1YS8pQ6NJ3cizIfvaB-9G8O-jvE/edit?usp=sharing",},

            {
                titulo:
                    "📒[slides] UNIT 9:COUNT AND NON-COUNT NOUNS WITH SOME, ANY, MUCH, MANY",
                url: "https://docs.google.com/presentation/d/1R2ynzoB6PCzWW1ZG3fCSQih98U_S_Q28/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            
            {
                titulo: "📒[slides]Some and Any",
                url: "https://docs.google.com/presentation/d/1UaeuTpsBrQ5b4bOdHJCvX-XNPiTP1Fze/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides]Super Market Sections and Partitives",
                url: "https://docs.google.com/presentation/d/1L-Hv6M6viuSIc11rB_guEbzdWonYLCBU/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "Some vs Any",
                url: "https://wordwall.net/play/19154/472/1306",
            },
            {
                titulo: "A/an vs Some vs Any",
                url: "https://wordwall.net/play/54748/815/185",
            },
            {
                titulo: "📒[slides] UNIT 7:TOO, ENOUGH, NOT … ENOUGH",
                url: "https://docs.google.com/presentation/d/1C-HqoKGLmr7z6xrd7YLKNvoAlZctuPlw/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 7:QUANTIFIERS",
                url: "https://docs.google.com/presentation/d/1F9jXNU0_7pHQNI31dAfLd2xG_6GoFj3r/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "A/Some/Any I Exercises",
                url: "https://wordwall.net/play/10233/308/44280",
            },
        ],
    },

    
    {
        id: 8,
        thumbnail:
            "https://i.ibb.co/0XR5yjD/990527648dc1fe389bb8568a632839e8-removebg-preview.png",
        title: "M2 - Past Tense I",
        subtitle: "Basic Level",

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            {titulo: "📖 UNIT 12:GOING TO",url: "https://docs.google.com/presentation/d/1SERr4FC0uid44aV7TBYFbu2UqdKgltiV/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true", },

            {titulo: "📖 be: Simple past  Affirmative and negative", url: "https://docs.google.com/presentation/d/1B7OI2bdC87AnfKKO4d_3Yhxim9zTeQGGzWCwc7AVkko/edit?usp=sharing",},
            {titulo: "📖 be: Simple past   Interrogative and short answers",url: "https://docs.google.com/presentation/d/1ml4Elz9yZMnjaPzktFBi7LLm5ZUYRgATCQtK72Rt-ZI/edit?usp=sharing", },
            {  titulo:"🧩 Simple Past was/were",url: "https://wordwall.net/play/62938/423/342" },

            {titulo: "📖 Question words  with was / were",url: "https://docs.google.com/presentation/d/1gTtHyLBBKmepH7uHASACv4X80e5k8IKI3bVQsjjP2DA/edit?usp=sharing",},
            {titulo: "📖 Simple past Regular verbs Affirmative", url: "https://docs.google.com/presentation/d/1DpJnvEGUNzzE77-OLCgYvyTMf-o0C_PXo9-e1SLx7Fc/edit?usp=sharing",},
            {  titulo:"🧩 Simple Past Regular Verbs",url: "https://wordwall.net/play/15209/196/99109" },
            {  titulo:"🧩 Simple Past Complete Regular Verbs",url: "https://wordwall.net/play/7639/322/54002" },

            {titulo: "📖 Simple past:  Irregular verbs Affirmative", url: "https://docs.google.com/presentation/d/19X3T5vbawbDcFFgxc2DlqfaFwaNsFkQMlFUsE9zgiPU/edit?usp=sharing", },
            {titulo: "📚 Los Verbos Irregulares ", url: "https://drive.google.com/file/d/1RpV1uLe-A215sfP1S954zi2zQs_XDvDg/view?usp=share_link", },
            { titulo: "📚 Los Verbos Irregulares II ", url: "https://drive.google.com/file/d/1EhALfkVQb-G5ylK9qMc674zmh8LWd-kT/view?usp=share_link",},
            {  titulo:"🧩 Simple Past Irregular Verbs",url: "https://wordwall.net/play/15208/131/43596" },
            {  titulo:"🧩 Simple Past Irregular Verbs II",url: "https://wordwall.net/play/25350/524/3505" },

            {titulo: "📖 Simple past  Negative",url: "https://docs.google.com/presentation/d/1VpPwGUKg1XsZNBatr46QYnss9emq0vN_pbj_bsXKg8A/edit?usp=sharing",},

            {titulo: "📖 Simple past   Interrogative and  short answers",url: "https://docs.google.com/presentation/d/19tQmwXnpFBPUgtg5mN2lAovJ7oQVMeTU9M_8WOPQIhY/edit?usp=sharing",},
            {  titulo:"🧩 Simple Past Order the",url: "https://wordwall.net/play/13891/224/58926" },

            {titulo: "📖 Question words + simple past",url: "https://docs.google.com/presentation/d/1xpXeEcVnzABaHDX-2agE6CjI3QL0QWi3SKhZiv6yYj4/edit?usp=sharing",},
            { titulo: "📖 SIMPLE PAST WITH WHEN CLAUSES",url: "https://docs.google.com/presentation/d/1gU_JXxoAp3KFVAe9-VI8pw-E7L4iXs_S/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true", },
            {
                titulo: "📒[slides] UNIT 5:PRESENT PERFECT AND SIMPLE PAST",
                url: "https://docs.google.com/presentation/d/1bpMRMy7LVba68bhwB6w2KUEXmD7n-MAP/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
          
            {  titulo:"🧩 Present Perfect VS sIMPLE PAST",url: "https://wordwall.net/play/3872/569/6556" },
            {  titulo:"🧩 Present Perfect VS sIMPLE PAST II",url: "https://wordwall.net/play/3580/893/7297" },

            
        ],
    },
    {
        id: 9,
        thumbnail:
            "https://i.ibb.co/rcqJNmR/Black-White-and-Red-Simple-Shield-Shape-Football-Club-Logo-4-removebg-preview.png",
        title: "Pronunciation 👄",
        subtitle: "Basic Level",
     

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            {
                titulo: "💣PRONUNCIACIÓN en INGLÉS (Presentación)👄",
                url: "https://www.youtube.com/watch?v=-YocPrBjydE&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&ab_channel=MyEnglishBro",
            },
            {
                titulo: "Trucos con la T",
                url: "https://www.youtube.com/watch?v=sh1-WReYeYY&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=2&ab_channel=MyEnglishBro",
            },
            {
                titulo: "Dropped T",
                url: "https://www.youtube.com/watch?v=MBPAI8TI-HA&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=3&ab_channel=MyEnglishBro",
            },
            {
                titulo: "T Flap",
                url: "https://www.youtube.com/watch?v=TAdE9TjixHk&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=4&ab_channel=MyEnglishBro",
            },
            {
                titulo: " Omission ",
                url: "https://www.youtube.com/watch?v=EbfroOu4_EU&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=5&ab_channel=MyEnglishBro",
            },
            {
                titulo: " T flap 2 ",
                url: "https://www.youtube.com/watch?v=8_-ABxzg3gE&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=6&ab_channel=MyEnglishBro",
            },
            {
                titulo: " T flap 3",
                url: "https://www.youtube.com/watch?v=w2BDLl5TVvA&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=7&ab_channel=MyEnglishBro",
            },
            {
                titulo: " T as Sh",
                url: "https://www.youtube.com/watch?v=VPFclhpx__s&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=8&ab_channel=MyEnglishBro",
            },
            {
                titulo: " Consideraciones al Pronunciar",
                url: "https://www.youtube.com/watch?v=717NdjUV9Po&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=9&ab_channel=MyEnglishBro",
            },
            {
                titulo: " T/D between 2 consonant sounds",
                url: "https://www.youtube.com/watch?v=vLUv888ckbk&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=10&ab_channel=MyEnglishBro",
            },
            {
                titulo: " Mastering Rhythm and Stress Presentation",
                url: "https://www.youtube.com/watch?v=z8aqyyXpfYg&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=11&ab_channel=MyEnglishBro",
            },
            {
                titulo: " Stress: The Missing Piece in Your English Pronunciation Puzzle",
                url: "https://www.youtube.com/watch?v=1ZQW2TETlZ4&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=12&ab_channel=MyEnglishBro",
            },
            {
                titulo: " Rhythm in English: Tips and Tricks for Improved Pronunciation and Fluency",
                url: "https://www.youtube.com/watch?v=IZk_QMWlq4o&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=13&ab_channel=MyEnglishBro",
            },
            {
                titulo: " Stress: The Missing Piece in Your English Pronunciation Puzzle II",
                url: "https://www.youtube.com/watch?v=yXhEUuVD9t0&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=14&ab_channel=MyEnglishBro",
            },
            {
                titulo: "The Power of Words: Understanding Content and Function Words",
                url: "https://www.youtube.com/watch?v=Qc4gX3xqHtA&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=15&ab_channel=MyEnglishBro",
            },
            {
                titulo: "Content vs. Function Words: The Building Blocks of Language",
                url: "https://www.youtube.com/watch?v=c1i7FNh9Sbc&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=16&ab_channel=MyEnglishBro",
            }
           



            
        ],
    },
    {
        id: 9,
        thumbnail:
            "https://i.ibb.co/rcqJNmR/Black-White-and-Red-Simple-Shield-Shape-Football-Club-Logo-4-removebg-preview.png",
        title: "A2-Past Progressive",
        subtitle: "Basic Level",
     

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            {
                titulo: "📒[slides] UNIT 1:PAST PROGRESSIVE",
                url: "https://docs.google.com/presentation/d/1HAWLxWFAbFNcrMbfGDVprjNC29Ziuw_N/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Explanation Past Progressive",
                url: "https://docs.google.com/presentation/d/1vdes1YGErLQlydpHdRVOv1MJcymHiNWr/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
           



            
        ],
    },
    {
        id: 10,
        thumbnail:
            "https://i.ibb.co/W2FY74b/level5.png",
        title: "Modal Verbs I",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            {titulo: "📒[slides] have to   Affirmative and negative",url: "https://docs.google.com/presentation/d/1ju_6UW5MqJkQx8ha63DXUkqdMIosY7yFkWo2VEFaBiM/edit?usp=sharing", },
            {titulo: "📒[slides] must / mustn’t",url: "https://docs.google.com/presentation/d/1trH8e--NmFTr9EVn-3bCGRiMmwg829FAfxcMiM0ZluY/edit?usp=sharing",},
            {titulo: "📒[slides] mustn’t / don’t have to", url: "https://docs.google.com/presentation/d/10cVuC3HrwV7jHSn_olYGfm3E_GibC-WeuJE3aB-mV_g/edit?usp=sharinge",},
            {
                titulo: "📒[slides] Can-Cannot Affirmative | Negative",
                url: "https://docs.google.com/presentation/d/1eKvqH6AOsKqLqqEudE2jChjZBn1bYSxq/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            {
                titulo: "📒[slides] Can-Cannot Questions",
                url: "https://docs.google.com/presentation/d/1Qpes0MERe7qfFf0ZK8JJHgPzcq3RZ4vF/edit?usp=share_link&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {titulo: "📒[slides] have to   Affirmative and negative",url: "https://docs.google.com/presentation/d/1ju_6UW5MqJkQx8ha63DXUkqdMIosY7yFkWo2VEFaBiM/edit?usp=sharing", },
            {titulo: "📒[slides] must / mustn’t",url: "https://docs.google.com/presentation/d/1trH8e--NmFTr9EVn-3bCGRiMmwg829FAfxcMiM0ZluY/edit?usp=sharing",},
            {titulo: "📒[slides] mustn’t / don’t have to", url: "https://docs.google.com/presentation/d/10cVuC3HrwV7jHSn_olYGfm3E_GibC-WeuJE3aB-mV_g/edit?usp=sharinge",},
            {
                titulo: "📒[slides] UNIT 3:MODALS OF PERMISSION, REQUEST, AND OFFER",
                url: "https://docs.google.com/presentation/d/1BXcYnCIF8JUQobGPG8BRQcBxLNTajgIu/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
           
            {
                titulo: "📒[slides] UNIT 5:SHOULD AND OUGHT TO FOR ADVICE",
                url: "https://docs.google.com/presentation/d/1UQ0jqkKaJld2WJKsdaDMUFhLDVHlxOu_/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo:
                    "📒[slides] UNIT 6:HAVE TO FOR OBLIGATION AND NEED TO FOR NECESSITY",
                url: "https://docs.google.com/presentation/d/1PzeZoVRIRqcpQ6BFvLJRYuOeC4UmQStn/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {  titulo:"📝Modal Verbs 01 ",url: "https://drive.google.com/file/d/1Zgn5KfbaEf7exIqRM68RQTYBMcoaTOoP/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 02 ",url: "https://drive.google.com/file/d/15KaDhw2YaEcm7wXwU9EDVmR7pGH-XmU0/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 03 ",url: "https://drive.google.com/file/d/1KZS2o5INbRPQompRGWlp1E37JdjTl91I/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 04 ",url: "https://drive.google.com/file/d/1IlbtmcVPxi2tVOnH5cpKvy7TgeyNgQkE/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 05 ",url: "https://drive.google.com/file/d/1TkRPNcrpra3uhWXzH4fMBWZu7J8NFBK_/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 06 ",url: "https://drive.google.com/file/d/1C5BNy8t3qK5Ke9cyVcWorPNVS07hcPH5/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 07 ",url: "https://drive.google.com/file/d/16enX5sTyWnLGlZxUMEBCNRfkPzWtVr2M/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 08 ",url: "https://drive.google.com/file/d/1lU75k9ZEKJM7wRsUpLz8LaUV6MuV8BRJ/view?usp=sharing"},

            


        ],
    },
    {
        id: 11,
        thumbnail:
            "https://i.ibb.co/rcqJNmR/Black-White-and-Red-Simple-Shield-Shape-Football-Club-Logo-4-removebg-preview.png",
        title: "M2-Past Simple vs Progressive",
        subtitle: "Basic Level",
     

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [

            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1GWFlQ8RvPK7qb3S8HLBhKTlBONeogy0H/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/18h8QAkzm5UIzr-TF3DywBw_F-KtkjUYY/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1LCS98Vmh3gzPntxzCx5kX_EdackIK0v_/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1gxGscWmK3hDwJTXbNQpUEKlWSh_J9VLG/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1_3IiO9AC-y6Ks5RZujHdQyaWKKeMO9pu/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1Cc3RqGtZefUPxDSohH0Xssr4OSO5uftZ/view?usp=sharing", },
            {  titulo:"✍️Practica Integradora 1", url: "https://docs.google.com/document/d/1dEid7CxmlAwFluGbugI-3zH__ktx_KrV/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true", },
            {  titulo:"✍️Test 01", url: "https://docs.google.com/document/d/1dEid7CxmlAwFluGbugI-3zH__ktx_KrV/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true", },

            
            {
                titulo: "📒[slides] UNIT 1:PAST PROGRESSIVE AND SIMPLE PAST",
                url: "https://docs.google.com/presentation/d/1D_k7NtZcVeZVozYIn4_Ub2ozwkub8uLP/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Explanation Past Progressive vs Past Simple",
                url: "https://docs.google.com/presentation/d/1OOieX_KRY80lbTVWR9iNmsQdeljR8p2u/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 2:COMPARATIVES WITHAS … AS / NOT AS … AS",
                url: "https://docs.google.com/presentation/d/13nJDZAQHhszP7Upr6VJdv4954_gwfHnP/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
           
            {
                titulo: "📒[slides] UNIT 3:REFLEXIVE PRONOUNS",
                url: "https://docs.google.com/presentation/d/1mH6MFHK3pXVZgHj7WOu4xvnRdZN9C3gJ/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },



            
        ],
    },
    {
        id: 27,
        thumbnail:
            "https://i.ibb.co/VL5G53c/My-english-bro-Personajek-09.png",
        title: "A2 KET RWRMC",
        subtitle: "A2 Key - Real World Reading Multiple Choice Exercises",

        dateAdded: "B2",
        channel: "A2 Key - Real World Reading Multiple Choice Exercises",
        description: "The first part of the A2 Key reading paper is multiple choice, where you read six real-world notices, messages and other short texts and choose the best answer for each question.",
        enlaces: [
          
            
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 1",
                url: "https://drive.google.com/file/d/1JeeC_duzkT3QIrcWs8Ue23U9AOaZ6IqN/view?usp=sharing",
            },
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 2",
                url: "https://drive.google.com/file/d/1ju7_uBsitSAoVs14dF5U8gcUeSBc5a79/view?usp=sharing",
            },
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 3",
                url: "https://drive.google.com/file/d/1NxShK0f8P6GVfKwgLQeGLPF8fyVuldJ6/view?usp=sharing",
            },
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 4",
                url: "https://drive.google.com/file/d/1TazVPeDKOQbqakaRKe9bn9UVmu65VcsM/view?usp=sharing",
            },
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 5",
                url: "https://drive.google.com/file/d/1AfU7hnDb0w_YfhNOyZCWF9saqAXd008O/view?usp=sharing",
            },
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 6",
                url: "https://drive.google.com/file/d/1pPD0QFFI5ReJMgrBtFijx2BhN2mpATlX/view?usp=sharing",
            },
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 7",
                url: "https://drive.google.com/file/d/1JVkLWglGz8sy9eUnmHef5DKQC-GhdWuE/view?usp=sharing",
            },
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 8",
                url: "https://drive.google.com/file/d/14MTJkZW2eBzxwsDNPO3YY00LwQziOKq9/view?usp=sharing",
            },
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 9",
                url: "https://drive.google.com/file/d/1DTnpcnD80ReKZTz-bgeqh1YJE4r1w7vR/view?usp=sharing",
            },
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 10",
                url: "https://drive.google.com/file/d/1CyrrIJxqHaoZsGTZuls7byl5CbD6Au3o/view?usp=sharing",
            },
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 11",
                url: "https://drive.google.com/file/d/1klqYbrrLgs5wlJcqA_yu6l1Epjg7OhN4/view?usp=sharing",
            },
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 12",
                url: "https://drive.google.com/file/d/1RdKnYH8iByQsTUTQiiYFPuAH_HToKYW7/view?usp=sharing",
            },
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 13",
                url: "https://drive.google.com/file/d/1USC9mBTTj5EQcqY5d48T3UxSjHZlMCrm/view?usp=sharing",
            },
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 14",
                url: "https://drive.google.com/file/d/1XvcrDs6uCXSfWWqAOrjzam0rcWm7d4G0/view?usp=sharing",
            },
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 15",
                url: "https://drive.google.com/file/d/1r6tBe3GC2Oxa1Rl5OmePJ6F8feUsW6hl/view?usp=sharing",
            },
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 16",
                url: "https://drive.google.com/file/d/10wRG5Czmg-azlbD7i86yS88pStNy05xb/view?usp=sharing",
            },
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 17",
                url: "https://drive.google.com/file/d/1V1xTIEFpjocPuASxJBcImLCRyTAe0FTq/view?usp=sharing",
            },
            {
                titulo: "📒[PDF] A2 Key Exam - Real World Reading Multiple Choice Exercise 18",
                url: "https://drive.google.com/file/d/19BXgSQCm7DHmhjJ2IpbOpg44ZeZPhNS_/view?usp=sharing",
            }

          
           
        ],
    },
    {
        id: 12,
        thumbnail:
            "https://i.ibb.co/0XR5yjD/990527648dc1fe389bb8568a632839e8-removebg-preview.png",
        title: "M3 - Present Perfect Tense",
        subtitle: "Basic Level",

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
           

            { titulo: "✍ Past and Present Perfect Tense - Simple Form",url: "https://drive.google.com/file/d/1D6keuz7pTkAnNv7mr2WRWoNIIlR5xaAu/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1GWFlQ8RvPK7qb3S8HLBhKTlBONeogy0H/view?usp=sharing", },

            { titulo: "✍ Past Tense: Simple and Progressive",url: "https://drive.google.com/file/d/1Cc3RqGtZefUPxDSohH0Xssr4OSO5uftZ/view?usp=sharing", },
            { titulo: "✍ B1 Simple Past , Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/10efo7YOPNaICX_E6_DQJsYZ5ctxm2xYQ/view?usp=sharing", },

           
            { titulo: "✍ Future Tense  ",url: "https://drive.google.com/file/d/1J6r3JFYzr-U4CzRQihyMcl6uB2Ms7bu0/view?usp=sharing", },
           
            {
                titulo: "📒[slides] UNIT 1: PRESENT PERFECT + YET/ALREADY",
                url: "https://docs.google.com/presentation/d/1RA-WHyxhAoZS3nE2GzwITzIArZLGDTeP/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },


            {
                titulo: "📒[slides] UNIT 4:PRESENT PERFECT— EVER/NEVER",
                url: "https://docs.google.com/presentation/d/12ccx9tsZGF_Ywm7pVc-YS5m2SXiV_g9U/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 4:PRESENT PERFECT—HOW LONG AND FOR/SINCE",
                url: "https://docs.google.com/presentation/d/1H5WPi2HTyUg7GHdLBuGZBXbnPHs5oG7S/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {  titulo:"🧩 Present Perfect Structure",url: "https://wordwall.net/play/3970/867/72998" },
            {  titulo:"🧩 Present Perfect FOR VS sINCE",url: "https://wordwall.net/play/12605/576/3362" },
           
            {
                titulo: "PRESENT PERFECT Exercises Grammar",
                url: "https://wordwall.net/play/20930/047/3447",
            },
            {
                titulo: "📒[slides] Explanation Present Perfect-Since and for",
                url: "https://docs.google.com/presentation/d/1nIn9oQtj9P7RcG5SwCXM_kFQOHYS3yin/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            {
                titulo: "Since and for",
                url: "https://wordwall.net/play/22172/068/39116",
            },
            {
                titulo: "📒[slides] SO, SUCH,TOO, ENOUGH",
                url: "https://docs.google.com/presentation/d/1-esOg7O9L2nl24VdBtrtRpCWM3BvhOyg/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] SEPARABLE AND NON-SEPARABLE PHRASAL VERBS",
                url: "https://docs.google.com/presentation/d/18JEefaYUzpFKO_NnwPuTsfK0ds4wSamk/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
        ],
    },
    {
        id: 13,
        thumbnail:
            "https://i.ibb.co/0XR5yjD/990527648dc1fe389bb8568a632839e8-removebg-preview.png",
        title: "General Vocabulary (B1)",
        subtitle: "Basic Level",

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            {
                titulo: "✍GV001 - MAKE and DO",url: "https://drive.google.com/file/d/1UEYWUuHD3FKzJJFSG_OP9lBEAqhUx54k/view?usp=sharing",
            },
            { titulo: "✍ GV002 - MAKE and DO",url: "https://drive.google.com/file/d/1QPzo8Ck0ZevE8NE4rk7sCKJ-j9dZfQVZ/view?usp=sharing", },

            { titulo: "✍ GV003 - Opposites",url: "https://drive.google.com/file/d/1xoPKqzxYNSvH8rBQnKnAN_xVMAL7aio2/view?usp=sharing", },

           
            { titulo: "✍ GV004 - Opposites  ",url: "https://drive.google.com/file/d/14KyyQcO_HlG1CH3D8p12D55cnA2HqkmF/view?usp=sharing", },
            { titulo: "✍ GV005 - MAKE, DO, HAVE and GET  ",url: "https://drive.google.com/file/d/1ezVaxDVz1rfXiSzDYpFgzXYKGp9SBhUJ/view?usp=sharing", },
            { titulo: "✍ GV006 - Opposites  ",url: "https://drive.google.com/file/d/1R6pbUOru-AXvwM9yOb3JqTtTGzws6CAC/view?usp=sharing", },
            { titulo: "✍ GV007 - Nouns and Activities  ",url: "https://drive.google.com/file/d/1pgo4T6hPx0ybXAzLonEYE1yRLC1W3UPd/view?usp=sharing", },



          
           

            
        ],
    },
    
    {
        id: 14,
        thumbnail:
            "https://i.ibb.co/0XR5yjD/990527648dc1fe389bb8568a632839e8-removebg-preview.png",
        title: "M4 - Past Simple Vs Present Perfect",
        subtitle: "Basic Level",

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            {
                titulo: "📒[slides] UNIT 5:PRESENT PERFECT AND SIMPLE PAST",
                url: "https://docs.google.com/presentation/d/1bpMRMy7LVba68bhwB6w2KUEXmD7n-MAP/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            { titulo: "✍ Past and Present Perfect Tense - Simple Form",url: "https://drive.google.com/file/d/1D6keuz7pTkAnNv7mr2WRWoNIIlR5xaAu/view?usp=sharing", },

            { titulo: "✍ B1 Simple Past , Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/10efo7YOPNaICX_E6_DQJsYZ5ctxm2xYQ/view?usp=sharing", },

           
            { titulo: "✍ Future Tense  ",url: "https://drive.google.com/file/d/1J6r3JFYzr-U4CzRQihyMcl6uB2Ms7bu0/view?usp=sharing", },
           



          
           

            
        ],
    },
    {
        id: 15,
        thumbnail:
            "https://i.ibb.co/0XR5yjD/990527648dc1fe389bb8568a632839e8-removebg-preview.png",
        title: "M4 - English Verb Patterns",
        subtitle: "Basic Level",

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            { titulo: "📒[slides] Transitive and Intransitive Verbs",url: "https://drive.google.com/file/d/1q9Ay8KRUU9tSwuHEvjIM8bKZ3PWCyjkZ/view?usp=sharing", },
            { titulo: "📒[slides] Lista de Verbos Seguidos por Gerunds and Infinitives",url: "https://drive.google.com/file/d/1afE2D6xqPTMRPTfk3Vci97FXlR82GIdZ/view?usp=sharing", },

            { titulo: "📒[slides] Gerunds and Infinitives Explanation",url: "https://drive.google.com/file/d/1rE08bQrEyF0TVO7FTYWGtLaiOGKuLjRO/view?usp=sharing", },
            { titulo: "✍  Gerunds and Infinitives Exercise 1",url: "https://drive.google.com/file/d/1KJKLqjSwQeILyViRun9ADqge1ikKPmSD/view?usp=sharing", },
            { titulo: "✍  Gerunds and Infinitives Exercise 2",url: "https://drive.google.com/file/d/19WY1c2LJZrAjj84niwx-u5dgh-dafQb6/view?usp=sharing", },
            { titulo: "✍  Gerunds and Infinitives Exercise 3",url: "https://drive.google.com/file/d/1xURjjQPkur3dYBtFRuZTmbnqlC-ZCb2b/view?usp=sharing", },
            { titulo: "💡  GI003 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1H6BxX1OPZ-5fU7peCACnw6vRV5-lnUPW/view?usp=sharing", },
            { titulo: "🔑  GI003 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1OYpGW81Wt7dvLTsTa7zddJRJIKKo7Mpn/view?usp=sharing", },
            { titulo: "💡  GI004 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1GOe8JtMyfLpayGkIgkUn1IkGRblKsoGf/view?usp=sharing", },
            { titulo: "🔑  GI004 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1iAOBovzOkjJH9Z9rToPCj8losTuXz9ov/view?usp=sharing", },
            { titulo: "🧩  Desafio gerund vs infinitive",url: "https://wordwall.net/play/7240/772/7948", },
            { titulo: "🧩  Desafio gerund vs infinitive II",url: "https://wordwall.net/play/22920/270/462", },
            { titulo: "🧩  Desafio gerund vs infinitive III",url: "https://wordwall.net/play/76232/915/656", },
            { titulo: "🧩  Desafio gerund vs infinitive IV",url: "https://wordwall.net/play/71477/712/378", },
            { titulo: "🧩  Desafio gerund vs infinitive V",url: "https://wordwall.net/play/75464/667/869", },
            { titulo: "🧩  Desafio gerund vs infinitive VI ",url: "https://wordwall.net/play/59257/372/969", },
            { titulo: "🧩  Desafio gerund vs infinitive VII ",url: "https://wordwall.net/play/4838/285/4447", },

           
           



          
            {
                titulo: "📒[slides] UNIT 5:PRESENT PERFECT AND SIMPLE PAST",
                url: "https://docs.google.com/presentation/d/1bpMRMy7LVba68bhwB6w2KUEXmD7n-MAP/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },

            
        ],
    },
    {
        id: 16,
        thumbnail:
            "",
        title: "M4.1-PRESENT PERFECT PROGRESSIVE",
        subtitle: "Intermediate",

        dateAdded: "Basic 03",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
          
          
           
            {
                titulo: "📒[slides] UNIT 6:COMPARATIVE AND SUPERLATIVE ADVERBS",
                url: "https://docs.google.com/presentation/d/1SnYrDzmfRjdf8anu2jEpfWCPl0SiF3go/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            
            
            {
                titulo: "📒[slides] UNIT 8:EXPRESSING LIKES, DESIRES, AND PREFERENCES",
                url: "https://docs.google.com/presentation/d/19fs3RnfAEOjH5UFWASRrvTDXqXHSmv1l/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 8:GERUND PHRASES AS SUBJECT AND OBJECT",
                url: "https://docs.google.com/presentation/d/1HlSz01uARuBa4IJGUoFPFqTNXyYJQvG5/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 9:MAY, MIGHT, AND WILL FOR FUTURE POSSIBILITY",
                url: "https://docs.google.com/presentation/d/1PWQNyUECVcbCtSV0OkzvYJIP5YZdXP9c/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 9:WILL AND GOING TO",
                url: "https://docs.google.com/presentation/d/1p1cDpBXO3UfCBi_sBAfjxYFVsdhS0V9C/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 10:INFINITIVES OF PURPOSE",
                url: "https://docs.google.com/presentation/d/1_xVAxKXnDL0uX7Z9ewv0ehBi4glkWSno/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 10:REVIEW OF FUTURE FORMS",
                url: "https://docs.google.com/presentation/d/1aHJTp1D5LRb03PXqWOzVaytcFyqh_pWh/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 11:SIMPLE PRESENT PASSIVE",
                url: "https://docs.google.com/presentation/d/1b7T_AF8RaiIb06d8kEI5yfeJtovbNIYW/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 11:SIMPLE PAST PASSIVE",
                url: "https://docs.google.com/presentation/d/1KSbZiuL-5LJsxu0kssRgR4LP42URrpjd/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            
           

            
          
           
            
            {
                titulo: "Word formation nouns & adjectives",
                url: "https://wordwall.net/play/29190/295/941",
            },
           

            {
                titulo: "📒[slides] Past Simple Verb be",
                url: "https://docs.google.com/presentation/d/1WuALZwdoDRnIAVWE_WubIVTQBdUWaDD3/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            {
                titulo: "Present Perfect vs Present Perfect Continuous",
                url: "https://wordwall.net/play/10820/227/9928",
            },

            {
                titulo: "📒[slides] Sports play-do-go",
                url: "https://docs.google.com/presentation/d/101h3-ahYugj93t3qG9FMO3-vQUdpKE5b/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "Match up punctuation",
                url: "https://wordwall.net/play/54005/079/927",
            },
            {
                titulo: "PUNCTUATION MARKS AND SYMBOLS",
                url: "https://wordwall.net/play/39412/815/652",
            },
            {
                titulo: "Punctuation-Quiz 1",
                url: "https://wordwall.net/play/198/432/8119",
            },

            {
                titulo: "Punctuation-Quiz 2",
                url: "https://wordwall.net/play/056/784/4681",
            },
            {
                titulo: "Sensory Verbs",
                url: "https://wordwall.net/play/34047/429/899",
            },

            {
                titulo: "although, however, in spite of, despite",
                url: "https://wordwall.net/play/26923/219/206",
            },
           
            {
                titulo: "Present Perfect vs Present Perfect Continuous",
                url: "https://wordwall.net/play/10820/227/9928",
            },

            { titulo: "🦻Dictation 1", url: "https://youtu.be/ZwbyLBkLnKU" },
            {
                titulo: "📒[slides] Explanation Used to",
                url: "https://docs.google.com/presentation/d/1TDItudKkMsiBgTFP_vf8GRr3lsTXjpfW/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Explanation Comparison As...As",
                url: "https://docs.google.com/presentation/d/1rMdmtkVa39vMk8j2ol8tf4Y4kQ-0Xxg6/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            {
                titulo: "📒[slides] Modal Verbs of Necessity ",
                url: "https://docs.google.com/presentation/d/1yLoUCJ7980tV_LN3QC_W7FeCAa4gUsua/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "Present Perfect vs Present Perfect Continuous",
                url: "https://wordwall.net/play/10820/227/9928",
            },
           
            {
                titulo: "Present Perfect vs Present Perfect Continuous",
                url: "https://wordwall.net/play/10820/227/9928",
            },
            {
                titulo: "although, however, in spite of, despite",
                url: "https://wordwall.net/play/26923/219/206",
            },
            {
                titulo: "PRESENT PERFECT Exercises Grammar",
                url: "https://wordwall.net/play/20930/047/3447",
            },

            {
                titulo: "Since and for",
                url: "https://wordwall.net/play/22172/068/39116",
            },
            {
                titulo: "Present Perfect vs Present Perfect Continuous",
                url: "https://wordwall.net/play/10820/227/9928",
            },

            { titulo: "🦻Dictation 1", url: "https://youtu.be/ZwbyLBkLnKU" },
            {
                titulo: "📒[slides] Time clauses I ",
                url: "https://docs.google.com/presentation/d/1jRjvfeYY0pNPABCDi0F7TxPhRtgvf2rJ/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Similarity and agreement",
                url: "https://docs.google.com/presentation/d/1aA5Q9LqM9nIxfgJ_QXrXPLKHuZtx2beu/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            { titulo: "🦻Dictation 1", url: "https://youtu.be/ZwbyLBkLnKU" },
            {
                titulo: "📒[slides] Pronunciation",
                url: "https://docs.google.com/presentation/d/1wZROGjhm3VuujA7nl2XsweDnzeCV0TQK/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            {
                titulo: "📒[slides] Inverted Conditionals",
                url: "https://docs.google.com/presentation/d/10RUYwHbZ3d_GMwCUHtVJu-P-JAYoS5z_/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Inversion Explanation",
                url: "https://docs.google.com/presentation/d/1WdtHxR3xkgJA9OY8FJ1yYassPo6CIGVw/edit?usp=share_link&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            { titulo: "🗣️Simulacion Visa 1", url: "https://youtu.be/rMfG3rYSlh0" },
            { titulo: "🦻Dictation 1", url: "https://youtu.be/ZwbyLBkLnKU" },
            {
                titulo: "although, however, in spite of, despite",
                url: "https://wordwall.net/play/26923/219/206",
            },
            

            
           
            {
                titulo: "linkers of addition and contrast ",
                url: "https://wordwall.net/play/8219/371/327",
            },
            {
                titulo: "linkers of addition and contrast ",
                url: "https://wordwall.net/play/8219/371/327",
            },
        ],
    },

    {
        id: 18,
        thumbnail:
            "",
        title: "M4 - Phrasal Verbs",
        subtitle: "Pre-Intermediate",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
            

            {  titulo:"🗃️ Phrasal Verbs ",    url: "https://quizlet.com/838893013/match/embed?i=2oqoxh&x=1jj1"},
            {  titulo:"🗃️ Phrasal Verbs 2 ",    url: "https://quizlet.com/828300727/match/embed?i=2oqoxh&x=1jj1"},
            {  titulo:"🗃️ Phrasal Verbs 3 ",    url: "https://quizlet.com/573335887/match/embed?i=2oqoxh&x=1jj1"},
            {  titulo:"🗃️ Examen ",    url: "https://quizlet.com/test-questions/phrasal-verbs-and-meanings-bcb74e59-84c0-4969-a808-add21e028e4d?i=2oqoxh&x=1kqt&__overrideABs=FeatureAccess-practiceTests"},

            {titulo: "📒Phrasal verb with Get",url: "https://drive.google.com/file/d/1txaA2U2EMDVKnJ--_UM8YhzDZBaHasDP/view?usp=sharing",},
            {titulo: "📒Phrasal verb with Take",url: "https://drive.google.com/file/d/1ZkjaNFOku-6MgJSzH_QRRXHoYGm02uLQ/view?usp=sharing",},
            {titulo: "📒Phrasal verb Get vs Take",url: "https://drive.google.com/file/d/1XyP5ABzwxOESdOwnOucJ_2-3beKDqxwv/view?usp=sharing",},
            {titulo: "📒Phrasal verb with Up",url: "https://drive.google.com/file/d/1B7kiX_3JXK8jiRYNFkR4IxPqoHCz0J7K/view?usp=sharing",},
            {titulo: "📒Phrasal verb Dictation",url: "https://drive.google.com/file/d/1Q78yaqJPpqUThoLZ4y5tqPFp-x6eCV8F/view?usp=sharing",},


         
            
            
        ],
    },
    {
        id: 19,
        thumbnail:
            "",
        title: "M4 - Relative Clauses I",
        subtitle: "Pre-Intermediate",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
            

            {titulo: "📒[slides] Relative Clauses Explanation",url: "https://drive.google.com/file/d/1cxrD9paWOcm3w7pLDmE_WvAVi2FJQI1x/view?usp=sharing",},
            
            {titulo: "📒[slides] Defining Relative Clauses Exercise 1",url: "https://drive.google.com/file/d/1vLOQ-v7JohxwCcGIeIPZRB0VEIvE1P5b/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 1 key",url: "https://drive.google.com/file/d/1eUbQC4nby3BU4ob6iXnWLBgn1ucZtzGv/view?usp=sharing",},

            {titulo: "📒[slides] Defining Relative Clauses Exercise 2",url: "https://drive.google.com/file/d/1zuEnn8IqoyVEFDGtioyJoAaF9beihzmL/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 2 key",url: "https://drive.google.com/file/d/1nAfUnBlJZYD6NAyXyrwcXyEGfEkGNMap/view?usp=sharing",},

            {titulo: "📒[slides] Defining Relative Clauses Exercise 3",url: "https://drive.google.com/file/d/1JHS5Kog6HeXhj5GMgKY6GoafIv69Leoj/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 3 key",url: "https://drive.google.com/file/d/1g6Bcda-4oWQ_1ugTLgn-X2l4lAvRbmF2/view?usp=sharing",},

            {titulo: "📒[slides] Defining Relative Clauses Exercise 4",url: "https://drive.google.com/file/d/1_yyKTGRy0f-fcCZ5BlRsMZXsBb2usP3g/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 4 key",url: "https://drive.google.com/file/d/1ug8Ybq084KuS4AMXVRJ76pN1rbYs93cA/view?usp=sharing",},
            {titulo: "[Grammar Worksheet] WHO 1 ",url: "https://drive.google.com/file/d/1cFrsL8KTttdqE4BpsR2YGCU2BG_SrfSf/view?usp=sharing",},
            {titulo: "[Grammar Worksheet] WHO 2 ",url: "https://drive.google.com/file/d/1HnZWwulcMoWRBuPlkGff-2xxJ9rX0x56/view?usp=sharing",},

            {titulo: "[Grammar Worksheet] WHOSE",url: "https://drive.google.com/file/d/10p5K6lvpYpdtEIhJNy-redgQ7aLBnVb2/view?usp=sharing",},

            {titulo: "[Grammar Quizz] Relative Clauses",url: "https://drive.google.com/file/d/1DqU2kvUjrAuTRfIzDQkpmleUANeWxnjP/view?usp=sharing",},
            {titulo: "[Grammar Quizz] WHO vs WHOSE",url: "https://drive.google.com/file/d/1Ab3XGgBtb8XhgPRFY-9K91ddlu_cEtpG/view?usp=sharing",},
            {titulo: "RC001 - Relative Clauses",url: "https://drive.google.com/file/d/1K8WkdJTAuJvGBwZcksUylm4xKDiC_efC/view?usp=sharing",},
            {titulo: "RC002 - Relative Clauses - Combine the TWO Sentences",url: "https://drive.google.com/file/d/1OFQyjqF7p2ppuJmqu76GnH3RlL4lkKzM/view?usp=sharing",},
            {titulo: "RC003 - Relative Clauses - Combine the TWO Sentences",url: "https://drive.google.com/file/d/1u24eoljpLI0AB8ROkDi-HSTenUlAubrj/view?usp=sharing",},
            {titulo: "RC004 - Relative Pronouns",url: "https://drive.google.com/file/d/19zQQNKYKQ3j81ooeAS7CLiG8klHE_2Qn/view?usp=sharing",},
            {titulo: "RC005 - Relative Clauses - Combine the TWO Sentences",url: "https://drive.google.com/file/d/1JwHY1cfaESrUMr9Dby2Gt21sxHRtZ5t6/view?usp=sharing",},
           

         
            
            
        ],
    },
   
    
    
    {
        id: 2,
        thumbnail:
            "",
        title: "M4 - Future Simple",
        subtitle: "Pre-Intermediate",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
            

            {titulo: "📒[slides] Present progressive for future",url: "https://docs.google.com/presentation/d/127VXd9ZK8i7BItgdXOik5VSWc9_G7dWRn7sMEbaFEUI/edit?usp=sharing",},

            {titulo: "📒[slides] Compounds: every",url: "https://docs.google.com/presentation/d/1RmaKN7jY5ej_nCVRgFSTI1b0tCMPx7IqZxLbHvDuK_E/edit?usp=sharing",},
           
            
            {titulo: "📒[slides] Comparative adjectives",url: "https://docs.google.com/presentation/d/1UwvUgRFxdCDPk648imeb3G9_V3rQ58e7UpvL7iD62lw/edit?usp=sharing", },
            {titulo: "📒[slides] Superlative adjectives", url: "https://docs.google.com/presentation/d/1EGA1g6Wx7aQTZYGeXUkK_PDeF3CXNLcU-sFWuhpxAmQ/edit?usp=sharing",},
            { titulo: "📒[slides] Verb + -ing form / infinitive", url: "https://docs.google.com/presentation/d/1V9GjtW5BRs2n4knhrQfQbeHkvLnJPP7tUTCmokQzeBQ/edit?usp=sharing",},

         
            
            
        ],
    },
    {
        id: 996,
        thumbnail:
            "https://i.ibb.co/0XR5yjD/990527648dc1fe389bb8568a632839e8-removebg-preview.png",
        title: "Passive Voice",
        subtitle: "Passive Voice",

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            { titulo: "✍ PA001 - Passive Voice - Sentence Building",url: "https://drive.google.com/file/d/1dnTe8P1YghBdXX-241IbAgBwY4Q906_R/view?usp=sharing", },
            { titulo: "✍ PA002 - Passive Voice - Change from active to passive",url: "https://drive.google.com/file/d/1X5b3MMuae1HeE6f2pG80DVQWKOtJ99WW/view?usp=sharing", },
            { titulo: "✍ PA003 - Passive Voice - Change from active to passive",url: "https://drive.google.com/file/d/1TM66uLQjlKIPkq3eli2yS3DVyoYY3lfO/view?usp=sharing", },
            { titulo: "✍ PA004 - Passive Voice - Change from active to passive",url: "https://drive.google.com/file/d/11pcdPewzO3xDQrajcgLqmIN1lycd8zhO/view?usp=sharing", },
            { titulo: "✍ PA005 - Passive Voice - Change from active to passive",url: "https://drive.google.com/file/d/1xwtUMjpat16Sz1Qc5ig4Dh2rB2Jldgr-/view?usp=sharing", },
            { titulo: "✍ PA006 - Passive Voice - Make sentences using the tenses in brackets ",url: "https://drive.google.com/file/d/12WGBkRNI1TTH3LYZiDrLCn0XjIWoeIbQ/view?usp=sharing", },

            { titulo: "✍ PA007 - Passive Voice - Fill in the correct verb form",url: "https://drive.google.com/file/d/1PxVvJ02voPDyx2w0WPLM2qSfvmImyxgC/view?usp=sharing", },
            { titulo: "✍ PA008 - Passive Voice - Change from active to passive ",url: "https://drive.google.com/file/d/1dYVPK0nnnPqC2A1cpx1h5MHHBNl4-mSW/view?usp=sharing", },

           
            { titulo: "✍ PA009 - Active and Passive Voice ",url: "https://drive.google.com/file/d/1hMKF8FFuuZJCcr8g-Uaky3fEdyRsj4B2/view?usp=sharing", },
            { titulo: "✍ PA010 - Passive Voice - Change from active to passive ",url: "https://drive.google.com/file/d/1kef-fwn5XS-mdpFtBsJNaiBv9O6tapqn/view?usp=sharing", },
            { titulo: "✍ PA011 - Passive Voice - Change from active to passive ",url: "https://drive.google.com/file/d/19frb1mIz5b0HzQ5x2mEuF_EUNGJcdal9/view?usp=sharing", },
            { titulo: "✍ PA012 - Passive Voice - Change from active to passive ",url: "https://drive.google.com/file/d/1NWjGsI_acbNQzoHhc7wvIcLjDkZ1T3Ps/view?usp=sharing", },
         
            { titulo: "✍ PA013 - Passive Voice - Change from active to passive ",url: "https://drive.google.com/file/d/1UDhwBHwvhaDM9Np6I8LXrGfNISgxidGZ/view?usp=sharing", },
            { titulo: "✍ PA014 - Passive Voice - Change from active to passive ",url: "https://drive.google.com/file/d/18kj21I16EGf-lcflLsecYN7oS8WLIXSH/view?usp=sharing", },
            { titulo: "✍ PA015 - Verb Tenses - Active or Passive Voice ",url: "https://drive.google.com/file/d/1J0928j_2Em_fLeSLqpxOImWcfcCCQv2L/view?usp=sharing", },
            { titulo: "✍ PA016 - A Local Sports Centre - Passive Voice ",url: "https://drive.google.com/file/d/1UZQPDIEmqOl0POB7gzbSnZo0zO6W9vzo/view?usp=sharing", },

            
        ],
    },
    {
        id: 2,
        thumbnail:
            "",
        title: "M5 - Conditionals",
        subtitle: "Pre-Intermediate",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
            
            {
                titulo: "📒[slides] UNIT 12:ZERO AND FIRST CONDITIONALS",
                url: "https://docs.google.com/presentation/d/1onYqAtCakGRcvxqsWTekI0t1RvDKsaFE/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 12:SECOND CONDITIONAL",
                url: "https://docs.google.com/presentation/d/1QsqN95d1bMRf3kkUx3glrk2VSBU0sQRd/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            
            { titulo: "✍ IF001 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/1zkFdLJpLESep41DLgUElfhiyuBzCU_fi/view?usp=sharing", },
            { titulo: "✍ IF002 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/1eQ-z-lbU8tKm_BZgrrgJwfkvl2Erbf2c/view?usp=sharing", },
            { titulo: "✍ IF003 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/182p9f-HK7c0eGODpwB3VstwcwQKgmtH7/view?usp=sharing", },
            { titulo: "✍ IF004 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/19z4Pi3T60d7n505lFrt22npAN8bMZG4d/view?usp=sharing", },
            { titulo: "✍ IF005 - IF-Clauses - Missing Sentence Types ",url: "https://drive.google.com/file/d/12FhAI14xsU_5O_Bau-AQFPIQPMwQrIPT/view?usp=sharing", },
            { titulo: "✍ IF006 - IF-Clauses - Missing Sentence Types ",url: "https://drive.google.com/file/d/1FiXA09T66glsOEsLQ6zJv86uzRS5NBAC/view?usp=sharing", },
            { titulo: "✍ IF008 - IF-Clauses - Conditional 1 ",url: "https://drive.google.com/file/d/1frj2F8CUX2wo_ASftPHyFFK037reIw9E/view?usp=sharing", },
            { titulo: "✍ IF009 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/1dk_3njjacg-x5I-707uoA6ieWhAB8TyU/view?usp=sharing", },
            { titulo: "✍ F010 - IF Clauses - Type 1 ",url: "https://drive.google.com/file/d/1cW9NMcLR6qwyc9TgGIgwcJl41iH9tWMA/view?usp=sharing", },
            { titulo: "✍ IF011 - IF Clauses - Type 2 ",url: "https://drive.google.com/file/d/1H_R3hcWhSwJCTfL____KykDG1pfuyoK5/view?usp=sharing", },
            { titulo: "✍ IF012 - IF Clauses - Type 3 ",url: "https://drive.google.com/file/d/1cG8XOFirGzvJJx7b_Xvv1c1uR38CuBlH/view?usp=sharing", },
        ],
    },
   
    
    {
        id: 27,
        thumbnail:
            "",
        title: "M7 -Advanced Structure",
        subtitle: "Upper-Intermediate",

        dateAdded: "B2",
        channel: "Upper-Intermediate",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
          
            
            {
                titulo: "📒[slides] UNIT 1: PRESENT PERFECT PROGRESSIVE",
                url: "https://docs.google.com/presentation/d/1FqSBQmJFZNO2J9n5wEfKEtQolqtEfwjv/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📝[test A] UNIT 1: Grammar and vocabulary PDF",
                url: "https://drive.google.com/file/d/1L55skpMyXpMfaYdK-6yiPbbRRi_vNPKa/view?usp=sharing",
            },
            {
                titulo: "📝[test A] UNIT 1: Grammar and vocabulary WORD",
                url: "https://docs.google.com/document/d/1qAHvstGrHBMUZtLFUfvkDTNTn_EnmLFT/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📝[test B] UNIT 1: Grammar and vocabulary PDF",
                url: "https://drive.google.com/file/d/1pxlAdQKDN4FgVQTvGyGASUpQEKjtMEYm/view?usp=sharing",
            },
            {
                titulo: "📝[test B] UNIT 1: Grammar and vocabulary WORD",
                url: "https://docs.google.com/document/d/1Ymc0Epm6ZmgFfY7CHSWcSdQ2aYcV6vJt/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📝[skill test] UNIT 1: Listening and writing PDF",
                url: "https://drive.google.com/file/d/1OEeWurlKS1ZyLyEpulrqzK5cLf_IZT5x/view?usp=sharing",
            },
            {
                titulo: "📝[skill test] UNIT 1: Listening and writing WORD",
                url: "https://docs.google.com/document/d/1guQo0Q-y3Aco5GDXw-gI1Mwu8QUM7ow2/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📽️[Video-Worksheet] Unit 1 Live and learn",
                url: "https://drive.google.com/file/d/1enqwoUPI9X2DsMFY9eChDFcMA7gdQYRR/view?usp=sharing",
            },
           
            
            {
                titulo: "📒[slides] USED TO ",
                url: "https://docs.google.com/presentation/d/1hjeM8uiiPSHFufWfJMxvbZpCndCN-2Mx/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] PAST PERFECT",
                url: "https://docs.google.com/presentation/d/1CRoJsRB9lUQ7wcOwYZ-X36vNNSC2azpV/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] DEFINITE ARTICLE THE/ ZERO ARTICLE ",
                url: "https://docs.google.com/presentation/d/1ZBSP1rFMLNbLTe5L2d3YypjHHHlz4wX2/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] INDIRECT QUESTIONS",
                url: "https://docs.google.com/presentation/d/10gHCV-87MTgk0ZZ52EJx4tccdINrVrKO/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] CAUSATIVE HAVE AND GET",
                url: "https://docs.google.com/presentation/d/1_3ahTLEy0-QeJ5oxKA0ns464-Q1h_grQ/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] ADJECTIVES ENDING IN –ED/–ING",
                url: "https://docs.google.com/presentation/d/1hm3JQyh9li96pP60B-ze_ao8iyuZh_pz/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] REPORTED SPEECH",
                url: "https://docs.google.com/presentation/d/1DYsVRlTghGCHSm4furCWTfgSRw1AyQvP/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] REPORTED QUESTIONS",
                url: "https://docs.google.com/presentation/d/1uHk_e865fl3aQ2hOAj0tn9CluY9ECNPO/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] THIRD CONDITIONAL",
                url: "https://docs.google.com/presentation/d/1uyQ6qwKGvw_gsli9GHbpawAtPMuVMtQX/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] HOPE AND WISH",
                url: "https://docs.google.com/presentation/d/1Z5q64p2CL0sbW4yNVZboFvGC4TRYUL13/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] MODALS OF DEDUCTION:MUST, CAN’T, MIGHT/MAY/COULD",
                url: "https://docs.google.com/presentation/d/1pSmzSB3VvxgMIN3qbrhxw7l3IRF2TZLN/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] TAG QUESTIONS",
                url: "https://docs.google.com/presentation/d/19LMGmlh76wTVirD9FpeWlUXW4df4gCtx/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] RELATIVE CLAUSES",
                url: "https://docs.google.com/presentation/d/1ktjlL9Ukjz8lbz2q7qeN5uH2cOxR16kz/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] VERB +GERUND/INFINITIVE",
                url: "https://docs.google.com/presentation/d/1JQDvauU0ttIP1M1Iqg9ZyOc4a4p4TA7A/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] INFINITIVE CLAUSES WITH IMPERSONAL IT",
                url: "https://docs.google.com/presentation/d/13Siio8SqdstUymNzgp3Gu4jXm2F5BKZF/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] WISH AND IF ONLY FOR REGRETS ",
                url: "https://docs.google.com/presentation/d/1WhyP0yVTi54ankXRvbVWQFYhMeiK1NMa/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] NON-DEFINING RELATIVE CLAUSES",
                url: "https://docs.google.com/presentation/d/1vFLgTr793gh3qUi339knm0ni_ILYPYTi/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] DEFINING RELATIVE CLAUSES",
                url: "https://docs.google.com/presentation/d/1znP8btGQWEZvO1VRSkBH-1gwp_oOhW44/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] SHOULD/SHOULDNT HAVE",
                url: "https://docs.google.com/presentation/d/1HU8mIm3lgulhGlGKHQFNjxg6ST9-azpk/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] WAS/WERE GOING TO AND WAS/WERE SUPPOSED TO",
                url: "https://docs.google.com/presentation/d/1tEdjjBe8-ipFATuc5IAFI9jsWoy2zZRp/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
           
        ],
    }, 
    {
        id: 99,
        thumbnail:
            "https://i.ibb.co/VL5G53c/My-english-bro-Personajek-09.png",
        title: "GUIAS MAESTRIA GRAMMAR ",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
           
           
          
            {  titulo:"[📑 Tense Infographic ", url: "https://drive.google.com/file/d/1Mxxxxi0x13HrO5EvSECowdaRF0Vg9fIK/view?usp=sharing"},

            {  titulo:"[📑 Present Simple", url: "https://drive.google.com/file/d/1uosvGKLwegu9ECo9TZTG3uJd79ku4_G2/view?usp=sharing"},
            {  titulo:"[📑 Present Progressive", url: "https://drive.google.com/file/d/15m5KpSZhu7Q1vop2-MiqlARFmY8jLx9u/view?usp=sharing"},
            {  titulo:"[📑 Past Simple", url: "https://drive.google.com/file/d/19wgEn7E6c-hBR1q08aSUU7ibHn8ERRl-/view?usp=sharing"},
            {  titulo:"[📑 Present Perfect", url: "https://drive.google.com/file/d/11x2FcIbUKSvFsAm2PyyfTOQ5zyYXE92i/view?usp=sharing"},

            {  titulo:"[📑 Present Perfect Progressive", url: "https://drive.google.com/file/d/1CoGNeh_2_0CkmXYzSkwugtCx185XJUp-/view?usp=sharing"},

        ],
    },
    {
        id: 26,
        thumbnail:
            "https://i.ibb.co/W2FY74b/level5.png",
        title: "Inglés con Anime",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Amplía tu vocabulario de manera efectiva y práctica con este curso diseñado para ayudarte a aprender y recordar nuevas palabras de forma rápida y duradera.",
        enlaces: [
            {  titulo:"🎥[Video] Aprende inglés con Dragon Ball Z - Conversaciones ",url: "https://drive.google.com/file/d/1wBA_z3emPwA8_7zG4PTh_3eM9kIrsw_G/view?usp=sharing"},
            {  titulo:"🎥[Video]  Picoro entrena a Gohan ",url: "https://drive.google.com/file/d/1cSJBlQ_0_N-hLgm4A-g-wNnv9U9x1lJZ/view?usp=sharing"},
            {  titulo:"🎥 [Video] Ingles con Naruto ",url: "https://drive.google.com/file/d/1olidUMObF_HhIZ0BMJGQrRpZERjm-euc/view?usp=sharing"},
            {  titulo:"🎥 [Video] El sacrificio de Vegeta ",url: "https://youtu.be/ce1JkqjXKJ4"},
            {  titulo:"🎥 [Video] Useful Expressions Death Note ",url: "https://youtu.be/MTaLzZikzv4"},
            {  titulo:"🎥 [Video] Useful Expressions One Punch Man ",url: "https://youtu.be/n_DcqiFayc4"},
            {  titulo:"🎥 [Video] La fusion de Vegito ",url: "https://youtu.be/ma7q6esT3cg"},
            {  titulo:"🎥 [Video] Useful Expression My hero Academy ",url: "https://youtu.be/8sPqgQlfKsQ"},
            {  titulo:"🎥 [Video] Useful Expression Goku enseña la tecnica de la Fusion ",url: "https://youtu.be/S5yooa_kHDY"},


        ],
    },
    {
        id: 27,
        thumbnail:
            "",
        title: "Duolinguo",
        subtitle: "Upper-Intermediate",

        dateAdded: "B2",
        channel: "Upper-Intermediate",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
          
            
            {
                titulo: "📒[slides] Read and Complete 1",
                url: "https://docs.google.com/presentation/d/12klLnHNvAHZ3BxdA7zVSdiY6UWZKgWjE/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Read and Complete 2",
                url: "https://docs.google.com/presentation/d/1eWCBSCR3CL8UfHAumCcc70V8l9AtOSaI/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Read and Complete Samples",
                url: "https://docs.google.com/document/d/1vKaqA0u7eHZeIBTfwp_m40DzPSqfD12J/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Read and Complete 3",
                url: "https://docs.google.com/presentation/d/1vDvxBxwAUQzF2BQJ8JLP8o6mBIbAmf0t/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Speaking Samples",
                url: "https://docs.google.com/document/d/13nEGPwnjIxDw6io6tBWyJTZ_uaMgWu9P/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true",
            }
           
        ],
    },
    
];
